/**
 * GadsKpi.js — GADS KPI Performance Dashboard (Freiseinapp Admin).
  * 24 ein-/ausblendbare Sektionen B-3 bis B20, lueckenlos. ⚠ Die Zaehlung ist die
 *   des DASHBOARDS, nicht die der b-Kommandos.
 *   (Stand 2026-10-19 22:55 GEZAEHLT: 24 Eintraege in BEREICHE, Keys bm3 bm2 bm1
 *    b00 b01..b20. Hier stand "23 bis B20" - der Kopf wurde beim Bau von B-3
 *    Kampagnen Strategie am selben Abend nicht nachgezogen; davor "19 bis B16",
 *    und eine Stunde lang "22", weil ich die Vor-Panels gerechnet statt gezaehlt
 *    hatte. 🔴 DREIMAL dieselbe Stelle falsch - die Zahl steht hier NUR als
 *    Lesehilfe, gezaehlt wird BEREICHE, nie dieser Kommentar.)
 * 🔴 KEY UND PLATZ SIND GLEICH (Georg 2026-10-19: "dann sollten wir das gleich
 *   glatt ziehen"). Vom 2026-10-13 bis zum 2026-10-19 fielen sie bei zwei Panels
 *   auseinander: Key `b00` sass auf Platz B-1, Key `bm1` auf B00 - genau vertauscht,
 *   weil Georg am 13.10. die Plaetze tauschte und die Keys blieben. Seither gilt:
 *   der Key IST die Platznummer, `bm` steht fuer minus. Kein Prozess-Satz war betroffen
 *   (`SELECT bericht, COUNT(*) FROM ads_objekt_prozess GROUP BY bericht` -> nur b01, b09).
 * B-1 Änderungsverlauf aus ads_changes (Komponente BM1Aenderungen, Endpunkt
 *   gads_kpi_aenderungen.php), B00 Markt aus ads_suchraum (Komponente B00Markt,
 *   Endpunkt gads_kpi_markt.php). Beide Endpunkte tragen SPRECHENDE Namen ohne
 *   Kuerzel - ein Kuerzel im Dateinamen war der Ort, an dem die Drift entstand.
 * Jede Sektion = Scroll-Bereich mit sichtbarem/klebrigem Header.
 * B01 gefüllt: Wochen- (Fr, letzte 7 T) + Monats-Berichte je Kampagne (Spalten = CSV-Export).
 * B02 gefüllt: reine IS-Bilanz je Woche (Fr–Do) + Monat/Kampagne (IS · Lost-Rang · Lost-Budget)
 *   via API-Fenster-Aggregat ab 01.01.2026. NUR eigene Daten — Konkurrenz-Domains bleiben der
 *   manuelle Import auf der Ads-Performance-Seite. IS=9,99 → Googles Maske „< 10 %" (masked-Flag,
 *   ehrlich angezeigt). oberste/obere bewusst NICHT hier (Dublette zu B01).
 * B03 gefüllt: Gerätebericht — je Gerät mit Traffic (Smartphones/Computer/Tablets; 0 Impr → keine
 *   Zeile) je Kampagne × Woche (Fr–Do) + Monat ab 01.01.2026. Additiv aus Tagestabelle aggregiert,
 *   oberste/obere per Fenster-Pull, Gebotsanpassung als aktuelles Setting.
 * B04 gefüllt: Altersdemografie — nur aktive Altersgruppen mit Traffic je Kampagne × Woche (Fr–Do)
 *   + Monat ab 01.01.2026. Additiv aus Tagestabelle, Gebotsanpassung als Setting. KEINE Anteils-
 *   metriken (API liefert IS/Lost-Rang/exact-match auf AGE_RANGE nicht).
 * B05 gefüllt: Standortbericht (Bundesland) — nur Standorte mit Traffic je Kampagne × Woche (Fr–Do)
 *   + Monat ab 01.01.2026. Additiv aus Tagestabelle ads_locations, Gebotsanpassung als Setting.
 *   KEINE oberste/obere (API liefert sie auf Location-Ebene nicht).
 * B06 gefüllt: Werbezeitplan — Tag × Daypart (6 Dayparts) mit Traffic je Kampagne × Woche (Fr–Do)
 *   + Monat ab 01.01.2026. Aus stündlicher Tagestabelle in Dayparts aggregiert, Gebotsanpassung
 *   als Setting. Conv-Wert/Alle-Conv nicht enthalten (=Conv).
 * B07 gefüllt: Zielgruppensegmente (Beobachtung) je Kampagne, Filter Klicks>0 (=CSV), einklappbar.
 *   Additiv aus Tagestabelle, Gebot uservertical-aufgelöst. Namen EN, kein Typ/keine Anteilsmetriken
 *   (API-Grenze).
 * B08 gefüllt: Suchbegriffe je Kampagne, Filter Status „Keines" (unbearbeitet), wöchentlich (Fr–Do)
 *   ab 01.01, einklappbar, MIT oberste/obere (Shares auf Search-Term-Ebene verfügbar). Direkt aus
 *   search_term_view (Tagestabelle hatte Status kaputt). GroupedReport-Flags shares/gebot.
 * B09 gefüllt: Keywords je Kampagne (ENABLED, negative=FALSE, inkl. 0-Impr wegen Max CPC), Wochen
 *   (Fr–Do) + Monate ab 01.01, einklappbar. Max CPC/QS/QS-Komponenten/Gesch. Gebote via extraCols
 *   (GroupedReport-Erweiterung). B10–B14 Platzhalter.
 */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './GadsKpi.css';

const API_BASE = '/api';

/* 🔴 DER PROZESS-SCHLUESSEL ENTSTEHT AN EINER STELLE (Georg 2026-10-19).
   Er verbindet eine Panel-Zeile mit ihrem Prozess-Satz und hat vier Teile:
   Kampagne, Periodenart, Periode und das OBJEKT. Die ersten drei sind in jedem
   Panel gleich; nur das Objekt ist panelweise verschieden - ein Keyword, ein
   Gerät, der Kampagnenname.

   WARUM EINE STELLE: Die Form stand bis zum 2026-10-19 viermal da, einmal je
   Panel mit eigener Zeile. Vier Schreibweisen derselben Sache laufen auseinander,
   und eine falsche fällt nicht auf - sie zeigt einfach nichts an. Genau das
   geschah in B01: der Schlüssel suchte das feste Wort `Kampagne`, die Sätze
   trugen den Kampagnennamen, und zwei Sätze lagen unsichtbar in der Tabelle.
   Gefunden hat es Georg, kein Prüfer.

   ⚠ Das OBJEKT bleibt beim Aufrufer. Es hier zu raten hiesse, die Panels zu
   kennen - und die Funktion müsste bei jedem neuen Panel geändert werden. */
const prozessKey = (r, objekt) => `${r.campaign}|${r.typ}|${r.zeitraum}|${objekt}`;

const BEREICHE = [
  // 2026-10-13 (Georg): Änderungen nach vorn auf B-1, Markt auf B00. Die KEYS bleiben,
  // wo sie waren - `b00` ist der Änderungsverlauf, `bm1` der Markt. Ein Tausch der Keys
  // hätte die Prozess-Sätze auf das falsche Panel zeigen lassen (Spalte `bericht`).
  // 2026-10-13 (Georg): B-2 Hist-Daten steht VOR allem anderen - die Hist-ID-Ebene
  // trägt jedes andere Panel. Key `bm2`, weil `bm1` schon vergeben ist; der Key ist
  // der stabile Teil, der Platz ist Anzeige.
  { key: 'bm3', label: 'B-3 · Kampagnen Strategie' },
  { key: 'bm2', label: 'B-2 · Hist-Daten' },
  { key: 'bm1', label: 'B-1 · Änderungen' },
  { key: 'b00', label: 'B00 · Markt' },
  { key: 'b01', label: 'B01 · Kampagne' },
  { key: 'b02', label: 'B02 · Auktionen' },
  { key: 'b03', label: 'B03 · Geräte' },
  { key: 'b04', label: 'B04 · Alter' },
  { key: 'b05', label: 'B05 · Standorte' },
  { key: 'b06', label: 'B06 · Werbezeitplan' },
  { key: 'b07', label: 'B07 · Zielgruppen' },
  { key: 'b08', label: 'B08 · Suchbegriffe' },
  { key: 'b09', label: 'B09 · Keywords' },
  { key: 'b10', label: 'B10 · Titel' },
  { key: 'b11', label: 'B11 · Texte' },
  { key: 'b12', label: 'B12 · Sitelinks' },
  { key: 'b13', label: 'B13 · Marke (Logo + Firma)' },
  { key: 'b14', label: 'B14 · Bilder' },
  // 2026-10-10 (Georg): B13 „Zusammenfassung" entfernt - sie hing an nichts und war
  // seit dem 2026-07-19 stillgelegt. Danach ab B12 in EINERSCHRITTEN durchgezaehlt,
  // die Sondernummern B12a/B12c sind weg. B13 Marke und B14 Bilder treffen sich damit
  // mit den gleichnamigen b-Kommandos; User-Intent liegt auf B15 (Kommando b16).
  { key: 'b15', label: 'B15 · User-Intent' },
  { key: 'b16', label: 'B16 · Journey' },
  // 2026-10-19 (Georg): B17 zeigt, was NACH der Anmeldung geschieht - die Kette endete
  // bisher beim CPA, und der CPA ist nur die iT-Anmeldung.
  { key: 'b17', label: 'B17 · Funnel' },
  { key: 'b18', label: 'B18 · Kosten' },
  { key: 'b19', label: 'B19 · Erträge' },
  { key: 'b20', label: 'B20 · Ergebnis' },
];

const KAMPAGNEN = [
  { code: 'VA', full: 'Verlustangst' },
  { code: 'EF', full: 'Eifersucht' },
  { code: 'EA', full: 'Emot. Abh.' },
  { code: 'SO', full: 'Souveränität' },
  { code: 'BR', full: 'Branding' },
];

const eur = n => (n == null ? '—' : Number(n).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €');
const pct = n => (n == null ? '—' : Number(n).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' %');
const num = n => (n == null ? '—' : Number(n).toLocaleString('de-DE'));

export default function GadsKpi() {
  const [open, setOpen] = useState({ b01: true });
  const toggle = k => setOpen(o => ({ ...o, [k]: !o[k] }));
  // 🔴 Beim Start sind nur die Kampagnen an, die noch Daten liefern (Georg 2026-10-10).
  // Bis die Messung da ist, bleibt alles aus - sonst blitzen die stillgelegten auf.
  const [selectedK, setSelectedK] = useState(Object.fromEntries(KAMPAGNEN.map(k => [k.code, false])));
  const [stand, setStand] = useState(null);
  const toggleK = c => setSelectedK(s => ({ ...s, [c]: !s[c] }));
  const setAll = v => setSelectedK(Object.fromEntries(KAMPAGNEN.map(k => [k.code, v])));

  /* 🔴 DER HIST-FILTER (Georg 2026-10-30: "eine Übersicht über alle offenen und
     geschlossenen Hist-Daten pro Panel ... nur die Panele anzeigen wo es offene oder
     geschlossene Hist-Sätze gibt ... als 2 Checkboxen"). Die Sätze kommen aus
     gads_kpi_hist.php (`op`, je Schlüssel der jüngste) - dieselbe Quelle wie B-2, kein
     zweiter Abruf je Panel. Beide aus: das Dashboard wie bisher. */
  const [histF, setHistF] = useState({ offen: false, geschlossen: false });
  const [histOp, setHistOp] = useState([]);
  const ladeHist = React.useCallback(() => {
    fetch(`${API_BASE}/gads_kpi_hist.php`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => { if (j.success) setHistOp(j.op || []); }).catch(() => {});
  }, []);
  useEffect(ladeHist, [ladeHist]);
  const histAktiv = histF.offen || histF.geschlossen;
  const histSichtbar = histOp.filter(s => selectedK[s.campaign] !== false
    && ((histF.offen && s.eingetreten == null) || (histF.geschlossen && s.eingetreten != null)));
  const histJe = k => histSichtbar.filter(s => s.bericht === k);
  const histZahl = kind => histOp.filter(s => selectedK[s.campaign] !== false
    && (kind === 'offen' ? s.eingetreten == null : s.eingetreten != null)).length;

  useEffect(() => {
    fetch(`${API_BASE}/gads_kpi_aktiv.php`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json())
      .then(j => {
        if (!j.success) { setAll(true); return; }           // ohne Messung lieber alle als keine
        setStand(j);
        const an = Object.fromEntries(KAMPAGNEN.map(k => [k.code, !!(j.kampagnen[k.code] || {}).aktiv]));
        setSelectedK(Object.values(an).some(Boolean) ? an : Object.fromEntries(KAMPAGNEN.map(k => [k.code, true])));
      })
      .catch(() => setAll(true));
  }, []);

  return (
    <div className="gk-wrap">
      <Link to="/admin" className="gk-back">← Zurück zum Dashboard</Link>
      <h2 className="gk-title">📊 GADS KPI Performance Dashboard <small>Kampagnen-Berichte B-3 bis B20</small></h2>

      <div className="gk-kfilter">
        <span className="gk-kfilter-lbl">Kampagnen:</span>
        {KAMPAGNEN.map(k => {
          const s = stand && stand.kampagnen[k.code];
          const still = s && !s.aktiv;
          return (
            <label key={k.code} className={'gk-kchk' + (selectedK[k.code] ? ' on' : '') + (still ? ' gk-still' : '')}
                   title={s ? `letzte Daten ${s.letzter} · vor ${s.tage_her} Tagen` : ''}>
              <input type="checkbox" checked={!!selectedK[k.code]} onChange={() => toggleK(k.code)} />
              <span>{k.code} <small>{k.full}{still ? ` · ${s.tage_her} T` : ''}</small></span>
            </label>
          );
        })}
        <button className="gk-kbtn" onClick={() => setAll(true)}>Alle an</button>
        <button className="gk-kbtn" onClick={() => setAll(false)}>Alle ab</button>
        {stand && (
          <span className="gk-toolbar-hint">
            vorausgewählt sind die Kampagnen mit Daten der letzten {stand.schwelle_tage} Tage —
            die anderen tragen ihren letzten Datentag. ⚠ gemessen wird „liefert Daten", nicht „ist aktiviert"
          </span>
        )}
      </div>

      <div className="gk-kfilter">
        <span className="gk-kfilter-lbl">Hist-Sätze:</span>
        {[['offen', 'offen'], ['geschlossen', 'geschlossen']].map(([k, t]) => (
          <label key={k} className={'gk-kchk' + (histF[k] ? ' on' : '')}>
            <input type="checkbox" checked={histF[k]} onChange={() => setHistF(f => ({ ...f, [k]: !f[k] }))} />
            <span>{t} <small>{histZahl(k)}</small></span>
          </label>
        ))}
        <span className="gk-toolbar-hint">
          angehakt: nur die Panels mit solchen Sätzen, je Panel eine Übersicht · beide aus: alle Berichte
        </span>
      </div>

      {histAktiv && histSichtbar.length === 0 && (
        <div className="gk-placeholder">Kein Hist-Satz für diese Auswahl in den gewählten Kampagnen.</div>
      )}

      {BEREICHE.filter(b => !histAktiv || histJe(b.key).length > 0).map(b => (
        <section className="gk-section" key={b.key}>
          <button className="gk-head" onClick={() => toggle(b.key)} aria-expanded={histAktiv || !!open[b.key]}>
            <span>{b.label}{histAktiv && <small> · {histJe(b.key).filter(s => s.eingetreten == null).length} offen
              · {histJe(b.key).filter(s => s.eingetreten != null).length} geschlossen</small>}</span>
            <span className="gk-caret">{histAktiv || open[b.key] ? '▾' : '▸'}</span>
          </button>
          {histAktiv && <div className="gk-body"><HistUebersicht bericht={b.key} saetze={histJe(b.key)} onGespeichert={ladeHist} /></div>}
          {!histAktiv && open[b.key] && (
            <div className="gk-body">
              {b.key === 'bm3' ? <BM3Strategie selectedK={selectedK} />
                : b.key === 'bm2' ? <BM2Hist selectedK={selectedK} />
                : b.key === 'bm1' ? <BM1Aenderungen selectedK={selectedK} />
                : b.key === 'b00' ? <B00Markt selectedK={selectedK} />
                : b.key === 'b01' ? <B01Kampagne selectedK={selectedK} />
                : b.key === 'b02' ? <B02Auktionen selectedK={selectedK} />
                : b.key === 'b03' ? <B03Geraete selectedK={selectedK} />
                : b.key === 'b04' ? <B04Alter selectedK={selectedK} />
                : b.key === 'b05' ? <B05Standorte selectedK={selectedK} />
                : b.key === 'b06' ? <B06Zeitplan selectedK={selectedK} />
                : b.key === 'b07' ? <B07Zielgruppen selectedK={selectedK} />
                : b.key === 'b08' ? <B08Suchbegriffe selectedK={selectedK} />
                : b.key === 'b09' ? <B09Keywords selectedK={selectedK} />
                : b.key === 'b10' ? <B10Titel selectedK={selectedK} />
                : b.key === 'b11' ? <B11Texte selectedK={selectedK} />
                : b.key === 'b12' ? <B12Sitelinks selectedK={selectedK} />
                : b.key === 'b13' ? <B13Marke selectedK={selectedK} />
                : b.key === 'b14' ? <B14Bilder selectedK={selectedK} />
                : b.key === 'b15' ? <B15UserIntent selectedK={selectedK} />
                : b.key === 'b16' ? <B16Journey selectedK={selectedK} />
                : b.key === 'b17' ? <B17Funnel />
                : b.key === 'b18' ? <B18Kosten />
                : b.key === 'b19' ? <B19Ertraege />
                : b.key === 'b20' ? <B20Ergebnis />
                : <div className="gk-placeholder">— Bericht folgt —</div>}
            </div>
          )}
        </section>
      ))}
    </div>
  );
}

// ================= Hist-Übersicht je Panel (Filter "Hist-Sätze") =================
// Eine Zeile je Satz, wie gads_kpi_hist.php ihn liefert. Codes statt Freitext - der
// Klartext steht in QualitCodes.md (Prozessbeschreibung Blatt 07 und 08).
// 🔴 EIN KLICK OEFFNET DEN SATZ (Georg 2026-10-30: "die Sätze kann ich nicht auswählen").
//    Darunter klappt dieselbe ProzessZeile auf wie im Panel, mit demselben Schluessel -
//    eine Eingabezone, kein Nachbau. Den vollen Satz laedt useProzess(bericht).
function HistUebersicht({ bericht, saetze, onGespeichert }) {
  const stand = s => s.eingetreten == null ? 'offen' : Number(s.eingetreten) === 1 ? 'eingetreten ja' : 'eingetreten nein';
  const [voll, ladeVoll] = useProzess(bericht);
  const [auf, setAuf] = useState({});
  const schl = s => `${s.campaign}|${s.periode_typ}|${s.periode}|${s.objekt}`;
  return (
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Satz</th><th>Kampagne</th><th>Periode</th><th>Objekt</th><th>Stufe</th>
          <th>Ursache</th><th>Handlung</th><th>H-Datum</th><th>Prüfdatum</th><th>Stand</th><th>Strategie · Etappe</th>
        </tr></thead>
        <tbody>
          {[...saetze].sort((a, b) => (a.eingetreten == null ? 0 : 1) - (b.eingetreten == null ? 0 : 1)
                                      || String(a.pruef_datum).localeCompare(String(b.pruef_datum))).map(s => (
            <React.Fragment key={s.id}>
            <tr className={(s.eingetreten == null ? 'gk-warn' : '') + (auf[s.id] ? ' gk-selected' : '')}
                style={{ cursor: 'pointer' }} title="Satz öffnen"
                onClick={() => setAuf(o => ({ ...o, [s.id]: !o[s.id] }))}>
              <td className="gk-nowrap">{auf[s.id] ? '▾' : '▸'} {s.id}</td>
              <td>{s.campaign}</td>
              <td className="gk-nowrap">{s.periode_typ} {s.periode}</td>
              <td>{s.objekt}</td>
              <td>{s.kp_stufe || '—'}</td>
              <td><code>{s.ursache_code || '—'}</code></td>
              <td><code>{s.handlung_code || '—'}</code></td>
              <td className="gk-nowrap">{s.h_datum || '—'}</td>
              <td className="gk-nowrap">{s.pruef_datum || '—'}{Number(s.verschoben) > 0 && ' ·v'}</td>
              <td>{stand(s)}</td>
              <td>{s.strat_name ? `${s.strat_name} · ${s.etap_nr}. ${s.etap_name}` : '—'}</td>
            </tr>
            {auf[s.id] && (
              <tr className="gk-detail">
                <ProzessZeile
                  bericht={bericht}
                  schluessel={{ campaign: s.campaign, periode_typ: s.periode_typ, periode: s.periode, objekt: s.objekt }}
                  satz={voll[schl(s)]}
                  gebotIst={undefined}
                  geoId={undefined}
                  onGespeichert={() => { ladeVoll(); onGespeichert && onGespeichert(); }}
                  spalten={11}
                />
              </tr>
            )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// ================= Prozess-Felder an einer Berichtszeile =================
// Georgs Festlegung 2026-10-10: ein Satz je PERIODEN-ZEILE, nicht je Objekt.
// Der Schlüssel ist (bericht, campaign, periode_typ, periode, objekt).
// Jeder Speichern-Klick schreibt eine neue Zeile in ads_objekt_prozess; der jüngste
// Satz gilt, die älteren sind die Historie. Bewusst als eigene Komponente gebaut,
// damit B04 ff. sie übernehmen können, ohne dass GroupedReport angefasst wird.

/** Die nächsten vier Freitage — Prüftermine fallen auf den KPI-Tag. */
function naechsteFreitage(n = 4) {
  const out = []; const d = new Date();
  for (let i = 1; out.length < n && i <= 70; i++) {
    const x = new Date(d.getTime() + i * 86400000);
    if (x.getDay() === 5) out.push(x.toISOString().slice(0, 10));
  }
  return out;
}

const PROZESS_LEER = { kp_stufe: '', ursache: '', handlung: '', h_datum: '', wirkhand: '', pruef_datum: '',
                       ergebnis: '', schluss: '', eingetreten: null, gebot_soll: '' };

/* 🔴 DIE kp-STUFEN (2026-10-19). Die Liste steht in api/gads_objekt_prozess.php als
   KP_STUFEN und kommt mit jeder GET-Antwort als `kp_stufen` mit - hier stehen nur die
   Beschriftungen. Eine zweite Definition der ZULAESSIGEN WERTE gibt es damit nicht:
   waehlt man eine, die der Server nicht kennt, antwortet er mit 400.
   Die Kette: Ressourcen/GADS KPI Perfomance Dashboard/Kampagnen-Performance/
              kp-Strategie-vom-Markt-zum-CPA.md, Abschnitt 4 */
const KP_STUFE_TEXT = {
  S0: 'S0 Rahmen — hat jemand etwas getan?',
  S1: 'S1 Markt — ist der Raum erschlossen?',
  S2: 'S2 Auktion — Rang oder Budget?',
  S3: 'S3 Impressionen — kommen genug an?',
  S4: 'S4 Klick — wird die Impression ein Klick?',
  S5: 'S5 Landung — wird der Klick eine Conversion?',
  S6: 'S6 Ertrag — CPA unter dem Ziel?',
  SM: 'SM Markt-Preis — traegt der Markt den Ziel-CPA? (zuletzt)',
};
/* Die Liste, die der Server mitliefert. Der Lader unten fuellt sie; bis dahin gilt die
   Notliste. Die ZULAESSIGEN Werte entscheidet ausschliesslich der Server (400 bei einem
   unbekannten) - die Notliste bestimmt nur, was zur Auswahl steht, nie was gilt. */
let KP_STUFEN_VOM_SERVER = null;
const KP_STUFEN_FALLBACK = ['S0','S1','S2','S3','S4','S5','S6','SM'];

/**
 * Was in der Prozess-Spalte steht, wenn die Zone ZU ist. Ohne das ist eine
 * gespeicherte Eingabe unsichtbar — die erste Rückmeldung aus dem Pilot.
 * Die Reihenfolge ist die des Ablaufs: Notiz → Handlung → Prüfung → Ergebnis.
 */
function prozessStand(s) {
  if (!s) return '';
  /* Die kp-Stufe steht VORAN, wenn sie gesetzt ist - sie sagt, in welchem Glied der
     Kette die Massnahme liegt, und das entscheidet, ob sie ueberhaupt etwas bewirken
     kann (der Zaun aus dem kp-Konzept, Abschnitt 4). */
  const st = s.kp_stufe ? s.kp_stufe + ' ' : '';
  if (s.eingetreten !== null) return st + (s.eingetreten ? '✓ eingetreten' : '✗ nicht eingetr.');
  if (s.ergebnis) return st + '✓ Ergebnis';
  if (s.pruef_datum) return st + `⏱ ${s.pruef_datum.slice(8, 10)}.${s.pruef_datum.slice(5, 7)}.`;
  if (s.handlung || s.gebot_soll != null) return st + '▸ Handlung';
  if (s.ursache) return st + '▸ Ursache';
  return st + '▸ Notiz';
}

function ProzessZeile({ bericht, schluessel, satz, gebotIst, geoId, onGespeichert, spalten, stufenListe }) {
  const [f, setF] = useState(() => ({ ...PROZESS_LEER, ...Object.fromEntries(
    Object.keys(PROZESS_LEER).map(k => [k, satz && satz[k] != null ? satz[k] : PROZESS_LEER[k]])) }));
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [hist, setHist] = useState(null);

  /* 🔴 Speichern nur bei Änderung (Georg 2026-10-12). Am 2026-10-12 um 15:20:18
     und 15:20:21 entstanden zwei inhaltlich gleiche Sätze — ein Doppelklick, der
     in der Auswertung als zwei Handlungen zählt. Der Server weist die Dublette
     ebenfalls ab; dieser Zustand sperrt schon den Klick. */
  const [stand, setStand] = useState(() => JSON.stringify(f));
  const geaendert = JSON.stringify(f) !== stand;

  const setz = (k, v) => { setF(s => ({ ...s, [k]: v })); setMsg(''); };

  const speichern = async () => {
    setBusy(true); setMsg('');
    try {
      const r = await fetch(`${API_BASE}/gads_objekt_prozess.php`, {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || ''), 'Content-Type': 'application/json' },
        body: JSON.stringify({ bericht, ...schluessel, ...f,
          eingetreten: f.eingetreten === null || f.eingetreten === '' ? null : Number(f.eingetreten),
          gebot_soll: f.gebot_soll === '' ? null : Number(f.gebot_soll) }),
      });
      const j = await r.json();
      if (j.success) {
        setStand(JSON.stringify(f));               // ab jetzt gilt dieser Stand als gespeichert
        setMsg(j.unveraendert ? 'keine Änderung' : 'gespeichert');
        onGespeichert && onGespeichert();
      }
      else setMsg('Fehler: ' + (j.message || 'unbekannt'));
    } catch (e) { setMsg('Fehler: ' + e); }
    setBusy(false);
  };

  // --- Gebot nach Google Ads übertragen: immer erst Dry-Run, dann der echte Write ---
  const [dry, setDry] = useState(null);     // Ergebnis des Probelaufs
  const [sendet, setSendet] = useState(false);

  const gebotRufen = async (action) => {
    setSendet(true); setMsg('');
    try {
      const r = await fetch(`${API_BASE}/gads_bid_mutate.php`, {
        method: 'POST',
        headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || ''), 'Content-Type': 'application/json' },
        // geo_id entscheidet im Endpunkt, ob ein Standort oder ein Gerät gemeint ist
        body: JSON.stringify({ action, campaign: schluessel.campaign,
          ...(geoId ? { geo_id: geoId, standort: schluessel.objekt } : { device: schluessel.objekt }),
          prozent: Number(f.gebot_soll), dry_token: dry ? dry.dry_token : undefined,
          bericht, objekt: schluessel.objekt,
          periode: schluessel.periode, periode_typ: schluessel.periode_typ }),
      });
      const j = await r.json();
      if (!j.success) { setMsg('Google: ' + (j.message || 'abgelehnt')); setDry(null); }
      else if (action === 'dry') { setDry(j); setMsg(''); }
      else {
        setDry(null);
        setMsg(j.bestaetigt
          ? `im Konto gesetzt: ${j.vorher_prozent == null ? 'keine' : j.vorher_prozent + ' %'} → ${j.jetzt_prozent} %`
          : `geschrieben, aber Rücklesen ergab ${j.jetzt_prozent}% statt ${j.soll_prozent}% — nachsehen`);
        onGespeichert && onGespeichert();
      }
    } catch (e) { setMsg('Fehler: ' + e); }
    setSendet(false);
  };

  /* 🔴 Die OBJEKT-Historie, nicht die Satz-Historie (Georg 2026-10-12).
     Die Satz-Historie endet, sobald der Schlüssel wechselt — eine neue Woche, ein
     anderer Match-Type, ein gewachsener Anzeigename. Über die Hist-ID läuft die Kette
     weiter. Kennt der Server kein Objekt (noch nicht migriert), fällt er auf die
     Satz-Historie zurück, und `objekthist` bleibt false. */
  const [objhist, setObjhist] = useState(null);       // { objekt, fassungen, historie }

  const kopf = () => ({ 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') });

  /* Historie DIESER Zeile: alle Speicherstände einer Woche unter diesem Namen. */
  const historieLaden = async () => {
    if (hist) { setHist(null); return; }
    setObjhist(null);
    const p = new URLSearchParams({ bericht, historie: '1', ...schluessel });
    const r = await fetch(`${API_BASE}/gads_objekt_prozess.php?${p}`, { headers: kopf() });
    const j = await r.json();
    setHist(j.success ? j.historie : []);
  };

  /* Historie des OBJEKTS: die Fassungen (was wann galt) plus alle Sätze der Kette -
     über alle Wochen und Namenswechsel hinweg. Das ist der Zweck der Hist-ID. */
  const objektLaden = async () => {
    if (objhist) { setObjhist(null); return; }
    setHist(null);
    const p = new URLSearchParams({ bericht, historie: '1', ueberObjekt: '1', ...schluessel });
    const r = await fetch(`${API_BASE}/gads_objekt_prozess.php?${p}`, { headers: kopf() });
    const j = await r.json();
    setObjhist(j.success ? j : { fehler: 'nicht ladbar' });
  };

  const ta = (k, lbl, ph) => (
    <label className="gp-f">
      <span>{lbl}</span>
      <textarea rows={2} value={f[k] || ''} placeholder={ph} onChange={e => setz(k, e.target.value)} />
    </label>
  );

  return (
    <td colSpan={spalten} className="gp-zelle">
      <div className="gp-grid">
        {/* Die Stufe steht VOR der Ursache: sie sagt, in welchem Glied der Kette der
            Befund liegt. Ohne sie kann die Ampel in B00 die Massnahme nicht zuordnen,
            und ap6 bleibt blind. Leer ist erlaubt - eine falsche Stufe nicht. */}
        <label className="gp-f gp-s">
          <span>kp-Stufe</span>
          <select value={f.kp_stufe || ''} onChange={e => setz('kp_stufe', e.target.value)}>
            <option value="">— ohne Stufe —</option>
            {(stufenListe || KP_STUFEN_VOM_SERVER || KP_STUFEN_FALLBACK).map(s => (
              <option key={s} value={s}>{KP_STUFE_TEXT[s] || s}</option>
            ))}
          </select>
        </label>
        {ta('ursache', 'Ursache', 'woran liegt der Befund?')}
        {ta('handlung', 'Handlung', 'was wird getan?')}
        <label className="gp-f gp-s">
          <span>H-Datum</span>
          <input type="date" value={f.h_datum || ''} onChange={e => setz('h_datum', e.target.value)} />
        </label>
        {ta('wirkhand', 'WirkHand', 'welche Wirkung wird vorhergesagt — mit einer prüfbaren Zahl')}
        <label className="gp-f gp-s">
          <span>Prüf-Datum</span>
          <input type="date" value={f.pruef_datum || ''} onChange={e => setz('pruef_datum', e.target.value)} list="gp-freitage" />
          <datalist id="gp-freitage">{naechsteFreitage().map(d => <option key={d} value={d} />)}</datalist>
        </label>
        {ta('ergebnis', 'Ergebnis', 'was am Prüfdatum gemessen wurde')}
        {ta('schluss', 'Schlussfolgerung', 'was daraus folgt')}
        <label className="gp-f gp-s">
          <span>eingetreten</span>
          <select value={f.eingetreten === null || f.eingetreten === '' ? '' : String(f.eingetreten)}
                  onChange={e => setz('eingetreten', e.target.value === '' ? null : Number(e.target.value))}>
            <option value="">— offen —</option><option value="1">ja</option><option value="0">nein</option>
          </select>
        </label>
        {gebotIst !== undefined && (
          <label className="gp-f gp-s">
            <span>Gebot (Soll, %)</span>
            <input type="number" step="1" min="-100" max="900" value={f.gebot_soll === null ? '' : f.gebot_soll}
                   placeholder={gebotIst == null ? 'keine gesetzt' : String(gebotIst)}
                   onChange={e => setz('gebot_soll', e.target.value)} />
            <small>Ist: {gebotIst == null ? '—' : (gebotIst > 0 ? '+' : '') + gebotIst + ' %'}</small>
          </label>
        )}
      </div>
      <div className="gp-bar">
        <button className="gk-kbtn" onClick={speichern} disabled={busy || !geaendert}
                title={geaendert ? 'Änderungen speichern' : 'nichts geändert'}>
          {busy ? '…' : '💾 Speichern'}
        </button>
        <button className="gk-kbtn" onClick={historieLaden} title="alle Speicherstände dieser Zeile">
          {hist ? 'Historie zu' : `Historie${satz && satz.saetze > 1 ? ` (${satz.saetze})` : ''}`}
        </button>
        <button className="gk-kbtn" onClick={objektLaden}
                title="die Kette dieses Objekts: was wann galt, über alle Wochen und Namenswechsel">
          {objhist ? 'Kette zu' : '🔗 Kette'}
        </button>
        {msg && <span className={msg.startsWith('Fehler') || msg.startsWith('Google:') ? 'gk-err' : 'gp-ok'}>{msg}</span>}
        {satz && satz.erstellt && <span className="gk-toolbar-hint">zuletzt gespeichert {satz.erstellt}</span>}
        {satz && satz.hist_id && <span className="gk-toolbar-hint" title="der lebenslange Schlüssel dieses Objekts">Hist-ID {satz.hist_id}</span>}
      </div>

      {/* 🔴 Der einzige Weg, der ins Google-Ads-Konto schreibt. Zwei Stufen, immer. */}
      {gebotIst !== undefined && f.gebot_soll !== '' && f.gebot_soll !== null && (
        <div className="gp-bar gp-mutate">
          {!dry ? (
            <>
              <button className="gk-kbtn" onClick={() => gebotRufen('dry')} disabled={sendet}>
                {sendet ? '…' : '① Bei Google prüfen'}
              </button>
              <span className="gk-toolbar-hint">
                prüft {f.gebot_soll > 0 ? '+' : ''}{f.gebot_soll} % für {schluessel.objekt} in {schluessel.campaign} — schreibt nichts
              </span>
              {satz && satz.gebot_gesetzt
                ? <span className="gp-ok">zuletzt ins Konto geschrieben: {satz.gebot_gesetzt}
                    {satz.gebot_vorher != null ? ` · vorher ${satz.gebot_vorher} %` : ' · vorher keine Anpassung'}</span>
                : <span className="gk-warn">bisher nur notiert, nicht im Konto</span>}
            </>
          ) : (
            <>
              <span className="gp-ok">
                Google hat geprüft und akzeptiert: {schluessel.campaign} · {dry.device} ·
                {dry.vorher_prozent == null ? ' keine Anpassung' : ` ${dry.vorher_prozent} %`} → {dry.nachher_prozent} %
              </span>
              <button className="gk-kbtn gp-scharf" onClick={() => gebotRufen('write')} disabled={sendet}>
                {sendet ? '…' : '② Jetzt im Konto setzen'}
              </button>
              <button className="gk-kbtn" onClick={() => setDry(null)} disabled={sendet}>abbrechen</button>
              <span className="gk-warn">Dieser Knopf ändert das laufende Konto.</span>
            </>
          )}
        </div>
      )}
      {hist && (
        <div className="gp-hist">
          <div className="gk-toolbar-hint">nur diese Zeile, dieser Zeitraum, dieser Name</div>
          {!hist.length ? <em>noch kein Satz gespeichert</em> : hist.map(h => (
            <div key={h.id} className="gp-histzeile">
              <strong>{h.erstellt}</strong>
              {h.ursache ? ` · Ursache: ${h.ursache}` : ''}{h.handlung ? ` · Handlung: ${h.handlung}` : ''}
              {h.h_datum ? ` · H ${h.h_datum}` : ''}{h.pruef_datum ? ` · Prüf ${h.pruef_datum}` : ''}
              {h.gebot_soll != null ? ` · Gebot-Soll ${h.gebot_soll} %` : ''}
              {h.eingetreten != null ? ` · eingetreten: ${Number(h.eingetreten) ? 'ja' : 'nein'}` : ''}
              {h.ergebnis ? ` · Ergebnis: ${h.ergebnis}` : ''}{h.schluss ? ` · Schluss: ${h.schluss}` : ''}
            </div>
          ))}
        </div>
      )}

      {/* 🔴 Die KETTE: was wann galt, über alle Wochen und Namenswechsel. Der Prozess-Satz
          sagt, was getan wurde; erst die Fassung sagt, was danach gilt (Georg 2026-10-12:
          „ich sehe nur das" — die Fassungen standen in der Datenbank und nirgends sonst). */}
      {objhist && (
        <div className="gp-hist">
          {!objhist.hist_id ? (
            <em>für dieses Objekt gibt es noch keine Kette — es ist nicht migriert</em>
          ) : (
            <>
              <div className="gk-toolbar-hint">
                Kette {objhist.hist_id}
                {objhist.objekt ? ` · ${objhist.objekt.art} · ${objhist.objekt.klasse}` : ''}
                {objhist.objekt && objhist.objekt.entstanden ? ` · entstanden ${objhist.objekt.entstanden}` : ''}
                {objhist.objekt && objhist.objekt.status ? ` · ${objhist.objekt.status}${objhist.objekt.status_seit ? ` seit ${objhist.objekt.status_seit}` : ''}` : ''}
              </div>

              <div className="gk-toolbar-hint">Fassungen — was wann galt</div>
              {!(objhist.fassungen || []).length ? <em>keine Fassung erfasst</em>
                : objhist.fassungen.map(v => (
                <div key={v.id} className="gp-histzeile">
                  <strong>{v.gueltig_ab} bis {v.gueltig_bis || 'heute'}</strong>
                  {v.match_type ? ` · ${v.match_type}` : ''}
                  {v.feld ? ` · ${v.feld}` : ''}
                  {v.inhalt ? ` · ${v.inhalt}` : ''}
                  {v.asset_id ? ` · Asset ${v.asset_id}` : ''}
                </div>
              ))}

              <div className="gk-toolbar-hint">Handlungen an diesem Objekt</div>
              {!(objhist.historie || []).length ? <em>noch keine Handlung</em>
                : objhist.historie.map(h => (
                <div key={h.id} className="gp-histzeile">
                  <strong>{h.erstellt}</strong>
                  {h.periode ? ` · ${h.periode}` : ''}
                  {h.objekt && h.objekt !== schluessel.objekt ? ` · damals: ${h.objekt}` : ''}
                  {h.handlung ? ` · ${h.handlung}` : ''}
                  {h.h_datum ? ` · H ${h.h_datum}` : ''}
                  {h.pruef_datum ? ` · Prüf ${h.pruef_datum}` : ''}
                  {h.eingetreten != null ? ` · eingetreten: ${Number(h.eingetreten) ? 'ja' : 'nein'}` : ''}
                </div>
              ))}
            </>
          )}
        </div>
      )}
    </td>
  );
}

/** Lädt die gespeicherten Sätze eines Berichts und gibt [saetze, neuLaden] zurück.
 *  bericht = null ist zulässig und lädt nichts — so kann GroupedReport den Hook
 *  bedingungslos aufrufen, auch wenn ein Panel keine Prozess-Felder hat. */
function useProzess(bericht) {
  const [saetze, setSaetze] = useState({});
  const laden = React.useCallback(() => {
    if (!bericht) return;
    fetch(`${API_BASE}/gads_objekt_prozess.php?bericht=${bericht}`,
      { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => {
        if (j.success) setSaetze(j.saetze || {});
        if (j.kp_stufen) KP_STUFEN_VOM_SERVER = j.kp_stufen;   // eine Wahrheit, vom Server
      })
      .catch(() => {});
  }, [bericht]);
  useEffect(laden, [laden]);
  return [saetze, laden];
}

// ---------- B17 · Funnel (2026-10-19) ----------
// WOZU: Die Kette endete beim CPA - und der CPA ist nur die iT-ANMELDUNG. Was danach
// kommt, stand in keinem Panel. Georg: „Wir könnten in B17 die Daten von kontakte
// wiederholen - nur anzeigen."
// 🔴 Das Panel ZEIGT, es urteilt nicht. Keine Ampel, keine Schwelle, kein Quervergleich.
// 🔴 Die Pflege-Zeile steht OBEN, nicht unten: eine Null bei einem Feld, das seit Monaten
//    niemand füllt, heißt „nicht gepflegt" und nicht „nicht passiert".
function B17Funnel() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/gads_kpi_b17.php?monate=12`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const alt = t => t === null ? '#9aa0a6' : t > 60 ? '#b3261e' : t > 30 ? '#8a6d00' : '#1a7f37';
  const monate = [...new Set(d.monate.map(m => m.monat))].sort().reverse();

  return (
    <>
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>Was nach der Anmeldung geschieht</strong> — aus <code>kontakte</code>, Stand {d.generated}.
      Die Tabelle gibt es erst seit <strong>{String(d.quelle.erster_satz).slice(0, 10)}</strong>; für die Zeit
      davor ist das Google Sheet die Quelle. Dieses Panel zeigt nur — es bewertet nicht.
    </span></div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={4}>Wie frisch ist jedes Feld?</th></tr>
          <tr><th>Feld</th><th>Pflege</th><th>zuletzt gefüllt</th><th className="r">Tage her</th></tr></thead>
        <tbody>
          {d.pflege.map(p => (
            <tr key={p.feld}>
              <td><code>{p.feld}</code></td>
              <td>{p.art === 'automatisch' ? 'automatisch' : <strong>von Hand</strong>}</td>
              <td>{p.letzte ? String(p.letzte).slice(0, 10) : '—'}</td>
              <td className="r" style={{ color: alt(p.tage) }}><strong>{p.tage ?? '—'}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        Eine <strong>0</strong> bei einem Feld, das seit Monaten niemand füllt, heißt
        „nicht gepflegt" — nicht „nicht passiert".
      </div>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={8}>Summe der letzten 12 Monate</th></tr>
          <tr>
            <th>Herkunft</th><th className="r">iT angemeldet</th><th className="r">iT besucht</th>
            <th className="r">Show-up</th><th className="r">Eg gebucht</th><th className="r">Eg je Besuch</th>
            <th className="r">Eg geführt</th><th className="r">Coaching</th>
          </tr></thead>
        <tbody>
          {d.summe.map(s => (
            <tr key={s.herkunft}>
              <td><strong>{s.herkunft}</strong></td>
              <td className="r">{s.it_gebucht}</td>
              <td className="r">{s.it_besucht}</td>
              <td className="r">{s.show_up_pct === null ? '—' : s.show_up_pct + ' %'}</td>
              <td className="r">{s.eg_gebucht}</td>
              <td className="r">{s.eg_pct === null ? '—' : s.eg_pct + ' %'}</td>
              <td className="r">{s.eg_gefuehrt}</td>
              <td className="r">{s.coaching}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={6}>Je Monat</th></tr>
          <tr>
            <th>Monat</th><th>Herkunft</th><th className="r">iT angemeldet</th>
            <th className="r">iT besucht</th><th className="r">Eg gebucht</th><th className="r">Eg geführt</th>
          </tr></thead>
        <tbody>
          {monate.map(mo => d.monate.filter(x => x.monat === mo).map((m, i) => (
            <tr key={mo + m.herkunft}>
              <td>{i === 0 ? <strong>{mo}</strong> : ''}</td>
              <td>{m.herkunft}</td>
              <td className="r">{m.it_gebucht}</td>
              <td className="r">{m.it_besucht}</td>
              <td className="r">{m.eg_gebucht}</td>
              <td className="r">{m.eg_gefuehrt}</td>
            </tr>
          )))}
        </tbody>
      </table>
      <div className="gk-note">
        <strong>gads</strong> trägt einen <code>gclid</code> und ist damit der Kampagne zuzuordnen;
        <strong> orga</strong> kam ohne Klick, <strong>ohne</strong> hat keinen Status — meist
        Buch-Leads. Die Stufen <strong>ab „Eg geführt"</strong> sind Handarbeit, siehe die
        Tabelle oben.
      </div>
    </div>
    </>
  );
}

// ---------- B20 · Ergebnis (2026-10-19) ----------
// Georg: „B20 die Ergebnisse mit Analyse". B17 zeigt den Funnel, B18 die Kosten,
// B19 die Erträge - B20 rechnet sie gegeneinander.
// 🔴 Die drei Grenzen stehen IM PANEL, nicht in einer Fußnote: Tool-Kosten sind nicht
//    kanalzuordenbar, die API-Kosten reichen nur bis 2026-01-01, und ein Ertrag gehört
//    zum Kanal seiner Entstehung, nicht zum Monat seines Eingangs.
function B20Ergebnis() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/gads_kpi_b20.php`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const g = d.grenzen || {};
  const gads = (d.kanal || []).find(k => k.herkunft === 'gads');

  return (
    <>
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>Trägt der Kanal?</strong> — Kosten gegen Erträge, Stand {d.generated}.
      GAds-Kosten <strong>{EUR(g.gads_kosten)}</strong> für {String(g.gads_von).slice(0, 10)} bis {String(g.gads_bis).slice(0, 10)}.
    </span></div>

    {gads && (
      <div className="gk-tablewrap">
        <table className="gk-table">
          <thead><tr><th colSpan={3}>Die eine Zahl</th></tr></thead>
          <tbody>
            <tr>
              <td style={{ fontSize: '1.3em' }}>
                <strong style={{ color: gads.saldo >= 0 ? '#1a7f37' : '#b3261e' }}>
                  {gads.je_euro != null ? `${gads.je_euro.toFixed(2).replace('.', ',')} €` : '—'}
                </strong><br /><small>Umsatz je ausgegebenem Euro</small>
              </td>
              <td>
                <strong style={{ color: gads.saldo >= 0 ? '#1a7f37' : '#b3261e' }}>{EUR(gads.saldo)}</strong>
                <br /><small>Saldo: {EUR(gads.netto)} zugeflossen − {EUR(gads.kosten)} Werbung</small>
              </td>
              <td>
                <strong>{gads.personen}</strong> zahlende {gads.personen === 1 ? 'Person' : 'Personen'}
                <br /><small>aus {gads.zahlungen} Zahlungen</small>
                {gads.personen <= 2 && (
                  <><br /><strong style={{ color: '#8a6d00' }}>
                    ⚠ bei {gads.personen} {gads.personen === 1 ? 'Person' : 'Personen'} trägt die Quote keine Prognose
                  </strong></>
                )}
              </td>
            </tr>
          </tbody>
        </table>
        <div className="gk-note">
          <strong>Ohne die Tool-Kosten.</strong> WebinarGeek, Zapier und Mailbutler tragen jede
          Anmeldung, gleich woher sie kam — sie lassen sich keinem Kanal zuordnen und stehen
          nur im Monatsblock. Wer sie anteilig einrechnete, bräuchte einen Schlüssel, den
          niemand gemessen hat.
        </div>
      </div>
    )}

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={7}>Je Kanal — über den ganzen Zeitraum</th></tr>
          <tr><th>Herkunft</th><th className="r">Zahlungen</th><th className="r">Personen</th>
              <th className="r">brutto</th><th className="r">zugeflossen</th>
              <th className="r">Werbekosten</th><th className="r">Saldo</th></tr></thead>
        <tbody>
          {(d.kanal || []).map(k => (
            <tr key={k.herkunft}>
              <td><strong>{k.herkunft}</strong></td>
              <td className="r">{k.zahlungen}</td><td className="r">{k.personen}</td>
              <td className="r">{EUR(k.brutto)}</td><td className="r">{EUR(k.netto)}</td>
              <td className="r">{k.kosten == null ? '—' : EUR(k.kosten)}</td>
              <td className="r" style={{ color: k.saldo == null ? undefined : (k.saldo >= 0 ? '#1a7f37' : '#b3261e') }}>
                <strong>{k.saldo == null ? '—' : EUR(k.saldo)}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        Werbekosten stehen nur bei <strong>gads</strong> — für die anderen Herkünfte gibt es
        keine zuordenbaren Ausgaben. Ein Ertrag zählt zu dem Kanal, über den die Person kam,
        nicht zum Monat, in dem die Zahlung einging.
      </div>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={3}>Der Funnel in Euro — GAds seit 2026-01-01</th></tr>
          <tr><th>Stufe</th><th className="r">Anzahl</th><th className="r">Kosten je Stück</th></tr></thead>
        <tbody>
          {(d.funnel || []).map(f => (
            <tr key={f.stufe}>
              <td>{f.stufe}</td><td className="r">{f.anzahl}</td>
              <td className="r"><strong>{f.kosten_je == null ? '—' : EUR(f.kosten_je)}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        Dieselben {EUR(g.gads_kosten)} auf jede Stufe verteilt — die Spalte sagt, was eine
        Stufe <em>bisher</em> gekostet hat, nicht was die nächste kosten wird.
      </div>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={5}>Je Monat — alle Kosten, alle Erträge</th></tr>
          <tr><th>Monat</th><th className="r">Google Ads</th><th className="r">Übriges</th>
              <th className="r">Erträge</th><th className="r">Saldo</th></tr></thead>
        <tbody>
          {(d.monate || []).map(m => (
            <tr key={m.monat}>
              <td>{m.monat}</td>
              <td className="r">{EUR(m.kosten_gads)}</td>
              <td className="r">{EUR(m.kosten_uebrig)}</td>
              <td className="r">{EUR(m.ertrag)}</td>
              <td className="r" style={{ color: m.saldo >= 0 ? '#1a7f37' : '#b3261e' }}>
                <strong>{EUR(m.saldo)}</strong></td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        {d.kuenftig && d.kuenftig.kosten > 0 ? (
          <>Dazu <strong>{EUR(d.kuenftig.kosten)}</strong> an bereits bezahlten
          Jahresverträgen, die sich bis <strong>{d.kuenftig.bis}</strong> weiter umlegen —
          sie stehen nicht in der Tabelle, weil der Monat noch nicht da ist.</>
        ) : 'Keine künftigen Vertragsanteile offen.'}
      </div>
    </div>
    </>
  );
}

// ---------- B18 · Kosten · B19 · Erträge (2026-10-19) ----------
// Georg trägt hier ein, was die API nicht liefert. Beide Panels teilen einen Endpunkt.
// 🔴 Google Ads wird NICHT eingetragen - die Zahlen kommen aus der API und stehen in der
//    Monatstabelle daneben. Der Server lehnt den Anbieternamen ab.
// 🔴 Ein Jahresvertrag verteilt sich über `gilt_von`/`gilt_bis` auf seine Laufzeit. Ohne
//    das sähe der Monat mit der Jahresrechnung teuer aus und die elf anderen billig.
const EUR = n => (n == null ? '—' : Number(n).toLocaleString('de-DE',
  { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €');

function useB18() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const token = () => 'Bearer ' + (localStorage.getItem('token') || '');

  const laden = useCallback(() => {
    fetch(`${API_BASE}/gads_kpi_b18.php`, { headers: { 'Authorization': token() } })
      .then(r => r.json()).then(j => { if (j.success) { setD(j); setErr(''); } else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);
  useEffect(laden, [laden]);

  const senden = async body => {
    setBusy(true);
    try {
      const r = await fetch(`${API_BASE}/gads_kpi_b18.php`, {
        method: 'POST',
        headers: { 'Authorization': token(), 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const j = await r.json();
      if (!j.success) { setErr(j.message || 'Fehler'); return false; }
      setErr(''); laden(); return true;
    } catch (e) { setErr(String(e)); return false; }
    finally { setBusy(false); }
  };
  return { d, err, busy, senden, laden };
}

function B18Kosten() {
  const { d, err, busy, senden } = useB18();
  const leer = { monat: new Date().toISOString().slice(0, 7), anbieter: '', kategorie: 'Software',
                 netto: '', mwst: '', gilt_von: '', gilt_bis: '', bemerkung: '' };
  const [f, setF] = useState(leer);
  const set = (k, v) => setF(o => ({ ...o, [k]: v }));

  if (!d && !err) return <div className="gk-placeholder">lädt…</div>;

  const brutto = (Number(String(f.netto).replace(',', '.')) || 0) + (Number(String(f.mwst).replace(',', '.')) || 0);

  /* 🔴 Diese Liste muss zur Validierung in gads_kpi_b18.php passen. Prüft der Knopf
     weniger als der Server, ist er aktiv und die Eingabe kommt als Fehlermeldung zurück -
     ohne zu sagen, welches Feld gemeint war. Das ist der Bruchfall aus
     [[Woran erkenne ich, dass ein Eingabefeld gebaut, aber nicht bedienbar ist]].
     Server verlangt: monat JJJJ-MM · anbieter · kategorie · netto+mwst=brutto ·
     gilt_von und gilt_bis nur zusammen. */
  const fehlt = [
    !f.monat && 'Zahlungsmonat',
    !f.anbieter && 'Anbieter',
    !f.netto && 'Netto',
    (!f.gilt_von !== !f.gilt_bis) && 'Laufzeit: von und bis nur zusammen',
  ].filter(Boolean);

  return (
    <>
    {err && <div className="gk-err">{err}</div>}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>Was die API nicht liefert</strong> — Tools, Hosting, Gebühren.
      <strong> Google Ads gehört nicht hierher</strong>: diese Zahlen kommen aus
      <code> ads_performance_campaigns</code> und stehen unten in der Monatstabelle.
      Für Altjahre vor 2026 den Anbieter <code>Google Ads (Rechnung)</code> benutzen.
      <br />Bei einem <strong>Jahresvertrag</strong> die Laufzeit eintragen — der Betrag
      wird dann auf die Monate verteilt statt dem Zahlungsmonat zugeschlagen.
    </span></div>

    {/* 🔴 Als FLIESSENDES Formular, nicht als Tabellenzeile. Die erste Fassung hatte acht
        Zellen nebeneinander - breiter als der Bildschirm, die Eingabefelder lagen rechts
        ausserhalb. Georg fand das Formular nicht (2026-10-19). */}
    <div className="gk-form">
      <h4 style={{ margin: '0 0 8px' }}>Neue Kostenzeile</h4>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end' }}>
        <label>Zahlungsmonat<br />
          <input type="month" value={f.monat} onChange={e => set('monat', e.target.value)} /></label>
        <label>Anbieter<br />
          <input value={f.anbieter} onChange={e => set('anbieter', e.target.value)} placeholder="Quentn" /></label>
        <label>Kategorie<br />
          <select value={f.kategorie} onChange={e => set('kategorie', e.target.value)}>
            {(d?.kategorien || []).map(k => <option key={k} value={k}>{k}</option>)}
          </select></label>
        <label>Netto<br />
          <input value={f.netto} onChange={e => set('netto', e.target.value)} placeholder="648,00" style={{ width: 100 }} /></label>
        <label>MwSt<br />
          <input value={f.mwst} onChange={e => set('mwst', e.target.value)} placeholder="123,12" style={{ width: 100 }} /></label>
        <div>Brutto<br /><strong style={{ fontSize: '1.1em' }}>{EUR(brutto)}</strong></div>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end', marginTop: 10 }}>
        <label>Laufzeit von <small>(nur bei Jahresvertrag)</small><br />
          <input type="date" value={f.gilt_von} onChange={e => set('gilt_von', e.target.value)} /></label>
        <label>bis<br />
          <input type="date" value={f.gilt_bis} onChange={e => set('gilt_bis', e.target.value)} /></label>
        <label style={{ flex: '1 1 200px' }}>Bemerkung<br />
          <input value={f.bemerkung} onChange={e => set('bemerkung', e.target.value)} style={{ width: '100%' }} /></label>
      </div>
      {/* 🔴 Eigene Zeile, und der Knopf sagt, WARUM er gesperrt ist. Vorher stand er
          klein neben der Bemerkung und war grau ohne Begruendung - Georg fragte
          zweimal, wo gespeichert wird (2026-10-19). */}
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 14 }}>
        {/* 🔴 Die Liste hier muss zur Validierung in gads_kpi_b18.php passen. Prüft der
            Knopf weniger als der Server, ist er aktiv und die Eingabe kommt als
            Fehlermeldung zurück - ohne zu sagen, welches Feld gemeint war.
            Server verlangt: monat (JJJJ-MM), anbieter, kategorie, netto+mwst=brutto. */}
        <button disabled={busy || !!fehlt.length}
          onClick={async () => { if (await senden({ teil: 'kosten', ...f })) setF(leer); }}>
          {busy ? 'speichert…' : 'Kosten eintragen'}</button>
        {!!fehlt.length && <small style={{ color: '#b3261e' }}>fehlt noch: {fehlt.join(' · ')}</small>}
      </div>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={4}>Je Monat — zwei Quellen, erst in der letzten Spalte addiert</th></tr>
          <tr><th>Monat</th><th className="r">Google Ads (API)</th><th className="r">Übriges (umgelegt)</th><th className="r">Summe</th></tr></thead>
        <tbody>
          {(d?.kosten_monat || []).map(m => (
            <tr key={m.monat}>
              <td>{m.monat}</td><td className="r">{EUR(m.api)}</td>
              <td className="r">{EUR(m.hand_umgelegt)}</td>
              <td className="r"><strong>{EUR(m.summe)}</strong></td>
            </tr>
          ))}
          {!(d?.kosten_monat || []).length && <tr><td colSpan={4}>— noch nichts erfasst —</td></tr>}
        </tbody>
      </table>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={8}>Einzelposten von Hand</th></tr>
          <tr><th>Monat</th><th>Anbieter</th><th>Kategorie</th><th className="r">Brutto</th>
              <th>Laufzeit</th><th className="r">je Monat</th><th>Bemerkung</th><th></th></tr></thead>
        <tbody>
          {(d?.kosten_hand || []).map(k => (
            <tr key={k.id}>
              <td>{k.monat}</td><td>{k.anbieter}</td><td>{k.kategorie}</td>
              <td className="r">{EUR(k.brutto)}</td>
              <td>{k.gilt_von ? `${k.gilt_von} – ${k.gilt_bis} (${k.laufzeit_monate} Mon.)` : '—'}</td>
              <td className="r">{k.laufzeit_monate > 1 ? EUR(k.je_monat) : '—'}</td>
              <td><small>{k.bemerkung}</small></td>
              <td><button disabled={busy} onClick={() => senden({ teil: 'kosten', id: k.id, loeschen: 1 })}>löschen</button></td>
            </tr>
          ))}
          {!(d?.kosten_hand || []).length && <tr><td colSpan={8}>— noch nichts erfasst —</td></tr>}
        </tbody>
      </table>
    </div>
    </>
  );
}

function B19Ertraege() {
  const { d, err, busy, senden } = useB18();
  const leer = { datum: new Date().toISOString().slice(0, 10), kontakte_id: '',
                 brutto: '', gebuehr: '', art: 'Coaching', bemerkung: '' };
  const [f, setF] = useState(leer);
  const [suche, setSuche] = useState('');
  const set = (k, v) => setF(o => ({ ...o, [k]: v }));

  if (!d && !err) return <div className="gk-placeholder">lädt…</div>;

  const s = suche.toLowerCase();
  const treffer = (d?.personen || []).filter(p => !s ||
    (p.name || '').toLowerCase().includes(s) || (p.email || '').toLowerCase().includes(s)).slice(0, 40);
  const gewaehlt = (d?.personen || []).find(p => String(p.id) === String(f.kontakte_id));
  const netto = (Number(String(f.brutto).replace(',', '.')) || 0) - (Number(String(f.gebuehr).replace(',', '.')) || 0);

  return (
    <>
    {err && <div className="gk-err">{err}</div>}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>Zahlungseingänge, einer Person zugeordnet.</strong> Über die Person wird der
      Kanal sichtbar — <code>kontakte.status</code> sagt, ob sie über GAds kam.
      Gespeichert wird <strong>nur die id</strong>, nie Name oder E-Mail.
      Eine Zahlung ohne Zuordnung ist erlaubt und zählt unter „ohne Zuordnung".
    </span></div>

    <div className="gk-form">
      <h4 style={{ margin: '0 0 8px' }}>Neuer Zahlungseingang</h4>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end' }}>
        <label>Datum<br />
          <input type="date" value={f.datum} onChange={e => set('datum', e.target.value)} /></label>
        <label>Brutto<br />
          <input value={f.brutto} onChange={e => set('brutto', e.target.value)} placeholder="395,00" style={{ width: 100 }} /></label>
        <label>Gebühr<br />
          <input value={f.gebuehr} onChange={e => set('gebuehr', e.target.value)} placeholder="12,18" style={{ width: 100 }} /></label>
        <div>Zugeflossen<br /><strong style={{ fontSize: '1.1em' }}>{EUR(netto)}</strong></div>
        <label>Art<br />
          <select value={f.art} onChange={e => set('art', e.target.value)}>
            {(d?.arten || []).map(a => <option key={a} value={a}>{a}</option>)}
          </select></label>
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'flex-end', marginTop: 10 }}>
        <label>Person suchen<br />
          <input value={suche} onChange={e => setSuche(e.target.value)} placeholder="Name oder E-Mail" /></label>
        <label style={{ flex: '1 1 320px' }}>Person<br />
          <select value={f.kontakte_id} onChange={e => set('kontakte_id', e.target.value)} style={{ width: '100%' }}>
            <option value="">— ohne Zuordnung —</option>
            {treffer.map(p => (
              <option key={p.id} value={p.id}>
                {/* it_am ist leer, wenn die Person nie am iT war - das kommt bei zahlenden
                    Kundinnen vor. Ohne die Abfrage stünde dort "iT null". */}
                {p.name} · {p.herkunft} · {p.it_am ? `iT ${p.it_am}` : 'ohne iT'}
                {p.zahlungen ? ` · ${p.zahlungen} Zahlungen` : ''}
              </option>
            ))}
          </select>
          {gewaehlt && <small>Herkunft: <strong>{gewaehlt.herkunft}</strong></small>}
        </label>
        <label style={{ flex: '1 1 200px' }}>Bemerkung<br />
          <input value={f.bemerkung} onChange={e => set('bemerkung', e.target.value)} style={{ width: '100%' }} /></label>
      </div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginTop: 14 }}>
        <button disabled={busy || !f.brutto}
          onClick={async () => { if (await senden({ teil: 'ertrag', ...f })) setF(leer); }}>
          {busy ? 'speichert…' : 'Zahlung eintragen'}</button>
        {!f.brutto && <small style={{ color: '#b3261e' }}>fehlt noch: Brutto</small>}
        {f.brutto && !f.kontakte_id && (
          <small style={{ color: '#8a6d00' }}>ohne Person — die Zahlung zählt dann unter „ohne Zuordnung"</small>
        )}
      </div>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={6}>Summe je Herkunft — das ist die Zahl, die gegen die Kosten geht</th></tr>
          <tr><th>Herkunft</th><th className="r">Zahlungen</th><th className="r">Personen</th>
              <th className="r">Brutto</th><th className="r">Gebühren</th><th className="r">Zugeflossen</th></tr></thead>
        <tbody>
          {(d?.ertrag_summe || []).map(s2 => (
            <tr key={s2.herkunft}>
              <td><strong>{s2.herkunft}</strong></td><td className="r">{s2.zahlungen}</td>
              <td className="r">{s2.personen}</td><td className="r">{EUR(s2.brutto)}</td>
              <td className="r">{EUR(s2.gebuehr)}</td><td className="r"><strong>{EUR(s2.netto)}</strong></td>
            </tr>
          ))}
          {!(d?.ertrag_summe || []).length && <tr><td colSpan={6}>— noch nichts erfasst —</td></tr>}
        </tbody>
      </table>
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr><th colSpan={8}>Einzelne Zahlungen</th></tr>
          <tr><th>Datum</th><th>Person</th><th>Herkunft</th><th className="r">Brutto</th>
              <th className="r">Gebühr</th><th className="r">Zugeflossen</th><th>Art</th><th></th></tr></thead>
        <tbody>
          {(d?.ertrag || []).map(e => (
            <tr key={e.id}>
              <td>{e.datum}</td><td>{e.person || <em>ohne Zuordnung</em>}</td>
              <td>{e.herkunft || '—'}</td><td className="r">{EUR(e.brutto)}</td>
              <td className="r">{EUR(e.gebuehr)}</td><td className="r">{EUR(e.netto)}</td>
              <td>{e.art}</td>
              <td><button disabled={busy} onClick={() => senden({ teil: 'ertrag', id: e.id, loeschen: 1 })}>löschen</button></td>
            </tr>
          ))}
          {!(d?.ertrag || []).length && <tr><td colSpan={8}>— noch nichts erfasst —</td></tr>}
        </tbody>
      </table>
    </div>
    </>
  );
}

// ---------- B15 · User-Intent ----------
// Georgs b16-Modell: der utm_term ist der einzige cookie-unabhängige Anker zwischen
// Klick und Journey, sein Preis steht in b09. Damit wandert das Geld in die Journey,
// und man liest ab, an welcher LP-Sektion a1–a11 es leckt.
function B15UserIntent({ selectedK }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [offen, setOffen] = useState({});

  useEffect(() => {
    fetch(`${API_BASE}/gads_kpi_b15.php?wochen=4`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt… (die Journey wird je Kampagne und Woche gerechnet)</div>;

  const an = r => !selectedK || selectedK[r.campaign];
  const kopf = d.kopf.filter(an).filter(k => k.besucher > 0 || k.budget_vw > 0);
  if (!kopf.length) return <div className="gk-placeholder">keine Kampagne ausgewählt — oder keine getrackten Besucher im Fenster</div>;

  const gk = k => `${k.campaign}|${k.zeitraum}`;
  const toggle = k => setOffen(o => ({ ...o, [k]: !o[k] }));

  return (
    <>
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      Geld je Suchstring, getragen in die LP-Journey — Zeile anklicken für Keywords und Sektionen. Stand {d.generated}
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Typ</th><th>Zeitraum</th><th>K</th>
          <th className="r">Budget Woche</th><th className="r">getrackt</th><th className="r">Stichprobe</th>
          <th className="r">Ø CPC</th><th className="r">konvertiert</th><th className="r">ohne Sektion</th>
          <th>Journey-Fenster</th>
        </tr></thead>
        <tbody>
          {kopf.map(k => {
            const key = gk(k);
            const auf = !!offen[key];
            const kws = d.kw.filter(x => x.campaign === k.campaign && x.zeitraum === k.zeitraum && x.eur > 0);
            const sek = d.sek.filter(x => x.campaign === k.campaign && x.zeitraum === k.zeitraum);
            const maxLeck = Math.max(1, ...sek.map(s => s.anteil));
            return (
              <React.Fragment key={key}>
                <tr className="gk-grouphead" onClick={() => toggle(key)}>
                  <td className="gk-nowrap"><span className="gk-caret">{auf ? '▾' : '▸'}</span> <span className="gk-badge gk-b-wk">{k.typ}</span></td>
                  <td className="gk-nowrap" style={{ fontWeight: 400 }}>{k.zeitraum}</td>
                  <td><strong>{k.campaign}</strong></td>
                  <td className="r">{eur(k.budget_vw)}</td>
                  <td className="r">{num(k.besucher)}</td>
                  <td className="r">{eur(k.stichprobe)}</td>
                  <td className="r">{eur(k.cpc_schnitt)}</td>
                  <td className="r">{k.conv_besucher > 0 ? `${k.conv_besucher} · ${eur(k.conv_eur)}` : <span className="gk-warn">0</span>}</td>
                  <td className="r">{k.ohne_sek || '—'}</td>
                  <td className="gk-muted2 gk-nowrap">{k.j_von} – {k.j_bis}</td>
                </tr>
                {auf && (
                  <tr className="gk-detail">
                    <td colSpan={10} className="gp-zelle">
                      <div className="gk-ui-split">
                        <div>
                          <strong>Woher das Geld kommt</strong> <span className="gk-toolbar-hint">— Preis exakt aus der Woche</span>
                          <table className="gk-table gk-ui-inner">
                            <thead><tr><th>Suchstring</th><th className="r">€</th><th className="r">Anteil</th><th className="r">CPC</th><th className="r">Klicks</th><th className="r">Conv.</th></tr></thead>
                            <tbody>{kws.length ? kws.map((x, i) => (
                              <tr key={i}><td>{x.kw}</td><td className="r">{eur(x.eur)}</td><td className="r">{pct(x.anteil)}</td>
                                <td className="r">{eur(x.cpc)}</td><td className="r">{num(x.klicks)}</td><td className="r">{x.conv}</td></tr>
                            )) : <tr><td colSpan={6} className="gk-muted2">kein Suchstring mit Kosten in dieser Woche</td></tr>}</tbody>
                          </table>
                        </div>
                        <div>
                          <strong>Wo es leckt</strong> <span className="gk-toolbar-hint">— Journey über 30 Tage</span>
                          <table className="gk-table gk-ui-inner">
                            <thead><tr><th>Sektion</th><th className="r">Besucher</th><th className="r">€ verloren</th><th>Anteil</th></tr></thead>
                            <tbody>{sek.map((s, i) => (
                              <tr key={i}>
                                <td>{s.sek}</td><td className="r">{num(s.besucher)}</td><td className="r">{eur(s.eur)}</td>
                                <td><span className="gk-ui-bar" style={{ width: Math.round(140 * s.anteil / maxLeck) + 'px' }} />
                                  {s.anteil > 0 ? ' ' + pct(s.anteil) : ''}</td>
                              </tr>
                            ))}</tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="gk-note">
        🔴 <strong>Zwei Zeitfenster in einer Zeile, und das ist Absicht.</strong> Der <strong>Preis</strong> kommt
        aus der gewählten Woche, exakt aus B09. Die <strong>Journey</strong> kommt aus 30 Tagen rückwärts — je Woche
        wären es zu wenige getrackte Besucher. Wer beides gegeneinander rechnet, vergleicht Verschiedenes.
        <br />⚠ <strong>Die Journey ist die eingewilligte Teilmenge.</strong> Die <em>Abbruchstelle</em> ist
        repräsentativ, die <em>absoluten Euro</em> sind eine Stichprobe. Die Verteilung ist das Signal, nicht die Summe.
        <br />Jeder getrackte Besucher trägt den CPC seines Suchstrings. Bricht er bei aX ab, ohne zu konvertieren,
        ist dieses Geld an aX verloren. „ohne Sektion" = kein SectionView-Event, der Weg ist unbekannt.
      </div>
    </div>
    </>
  );
}

// ---------- B16 · Journey ----------
// Eine Zeile je getracktem Besucher. Wo B15 das Geld zeigt, zeigt B16 die Menschen:
// wer kam, über welchen Suchstring, wie weit er las und wo er aufhörte.
function B16Journey({ selectedK }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [offenG, setOffenG] = useState({});
  const [nurBezahlt, setNurBezahlt] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/gads_kpi_b16.php?wochen=10`, { headers: { 'Authorization': 'Bearer ' + (localStorage.getItem('token') || '') } })
      .then(r => r.json()).then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const shown = d.rows.filter(r => (!selectedK || selectedK[r.campaign]) && (!nurBezahlt || r.bezahlt === 'ja'));
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt — oder keine getrackten Besucher</div>;

  const groups = []; const gmap = {};
  shown.forEach(r => {
    const k = `${r.typ}|${r.zeitraum}|${r.campaign}`;
    if (!gmap[k]) { gmap[k] = { key: k, ...r, rows: [] }; groups.push(gmap[k]); }
    gmap[k].rows.push(r);
  });
  const toggle = k => setOffenG(o => ({ ...o, [k]: !o[k] }));
  // über eine Stunde heißt fast immer: der Tab blieb offen, nicht gelesen
  const lang = s => s > 3600;

  return (
    <>
    <div className="gk-toolbar">
      <button className={'gk-kbtn' + (nurBezahlt ? ' on' : '')} onClick={() => setNurBezahlt(v => !v)}>
        {nurBezahlt ? 'alle zeigen' : 'nur bezahlte'}
      </button>
      <button className="gk-kbtn" onClick={() => setOffenG(Object.fromEntries(groups.map(g => [g.key, true])))}>Alle auf</button>
      <button className="gk-kbtn" onClick={() => setOffenG({})}>Alle zu</button>
      <span className="gk-toolbar-hint">{groups.length} Gruppen · {shown.length} Besucher · ab {d.ab}</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Typ</th><th>Zeitraum</th><th>K</th><th>Besucher</th><th>Suchstring</th><th>Quelle</th>
          <th>Gerät</th><th className="r">Sektionen</th><th>Weg</th><th className="r">Dauer</th>
          <th className="r">CTA</th><th className="r">Video</th>
        </tr></thead>
        <tbody>
          {groups.map(g => {
            const auf = !!offenG[g.key];
            const bez = g.rows.filter(r => r.bezahlt === 'ja').length;
            const cta = g.rows.reduce((s, r) => s + r.cta, 0);
            const schnitt = Math.round(g.rows.reduce((s, r) => s + Math.min(r.dauer_s, 3600), 0) / g.rows.length);
            return (
              <React.Fragment key={g.key}>
                <tr className="gk-grouphead" onClick={() => toggle(g.key)}>
                  <td className="gk-nowrap"><span className="gk-caret">{auf ? '▾' : '▸'}</span> <span className="gk-badge gk-b-wk">{g.typ}</span></td>
                  <td className="gk-nowrap" style={{ fontWeight: 400 }}>{g.zeitraum}</td>
                  <td><strong>{g.campaign}</strong></td>
                  <td className="gk-muted2" colSpan={4}>{g.rows.length} Besucher · davon {bez} bezahlt</td>
                  <td className="r">{Math.round(g.rows.reduce((s, r) => s + r.sektionen, 0) / g.rows.length)} Ø</td>
                  <td className="gk-muted2">Ø-Dauer gedeckelt bei 60 min</td>
                  <td className="r">{schnitt >= 60 ? Math.floor(schnitt / 60) + ':' + String(schnitt % 60).padStart(2, '0') + ' min' : schnitt + ' s'}</td>
                  <td className="r">{cta || '—'}</td><td className="r"></td>
                </tr>
                {auf && g.rows.map((r, i) => (
                  <tr key={i} className="gk-detail">
                    <td></td><td></td><td></td>
                    <td className="gk-nowrap gk-muted2">{r.wann}</td>
                    <td className="gk-nowrap">{r.term}</td>
                    <td className="gk-nowrap">{r.bezahlt === 'ja' ? <strong>bezahlt</strong> : <span className="gk-muted2">organisch</span>}</td>
                    <td className="gk-nowrap gk-muted2">{r.geraet}</td>
                    <td className="r">{r.sektionen}</td>
                    <td className="gk-nowrap">{r.erste_sek} → <strong>{r.letzte_sek}</strong></td>
                    <td className={'r' + (lang(r.dauer_s) ? ' gk-warn' : '')} title={lang(r.dauer_s) ? 'über eine Stunde — vermutlich ein offener Tab, keine Lesezeit' : ''}>
                      {r.dauer}{lang(r.dauer_s) ? '*' : ''}
                    </td>
                    <td className="r">{r.cta || ''}</td>
                    <td className="r">{r.video || ''}</td>
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="gk-note">
        Eine Zeile je getracktem Besucher aus der eigenen Tracking-Kette (<code>events</code>), nicht aus Google.
        Die Kampagne steht in <code>utm_campaign</code>, die Sektion in <code>section_name</code>.
        <br />⚠ <strong>Nur die eingewilligte Teilmenge</strong> — gegen die Impressionen derselben Zeit ist das eine
        Stichprobe. Die <em>Wege</em> sind aussagekräftig, die <em>Anzahl</em> nicht.
        <br />⚠ Ein <strong>*</strong> bei der Dauer heißt: über eine Stunde, also fast sicher ein offener Tab und
        keine Lesezeit. Der Gruppen-Durchschnitt deckelt solche Werte bei 60 Minuten, sonst verzerrt ein einziger
        Besucher die ganze Woche. Die Woche richtet sich nach dem <strong>ersten</strong> Event eines Besuchers.
      </div>
    </div>
    </>
  );
}

// ---------- B-2 · Hist-Daten ----------
// Das Panel VOR allen anderen: die Hist-ID-Ebene, auf der jedes andere Panel steht.
// Georgs Festlegung 2026-10-13: „B-2 | Hist-Daten | Ketten, Fassungen, Trefferquote".
// Vier Blöcke — die Ketten, die Fassungswechsel, die Prognosen auf Objektebene und
// daneben die auf Kampagnenebene (ads_prognosen), die ein Richter beurteilt.
//
// 🔴 DIE TREFFERQUOTE NENNT IHREN NENNER. `eingetreten` ist NULL, solange das Prüfdatum
//    nicht erreicht ist; „0 von 0 beurteilt" ist die ehrliche Angabe, „0 Prozent" wäre
//    eine Behauptung über sieben Prognosen, die noch laufen.
// 🔴 DER ABSTAND IST LEER UND BLEIBT ES, bis Soll und Ist als Zahl in Spalten stehen.
//    `wirkhand` ist Freitext („steigen von 7 je 30 Tage auf über 15") — die erste Zahl
//    darin ist die Basis, nicht das Soll. Ein gerechneter Abstand wäre falsch.
/* ---------- B-3 Kampagnen Strategie (ks) ----------
 * Georg 2026-10-19: "Der Agent muss sehen welche Strategie gefahren wird, wo sie steht,
 * was getan wurde, was ist noch offen, was sind die aktuellen Ergebnisse, ist die ks auf
 * dem richtigen Weg etc."
 *
 * 🔴 DIE FRAGE "traegt sie" WIRD NICHT BEANTWORTET, sondern BELEGT: drei Zahlen
 *    (eingetreten, verfehlt, offen) und das Ziel daneben. Eine Ampel hier waere ein
 *    Urteil ohne Zaun - die kp-Kette hat einen, diese Ebene nicht.
 * ⚠ `ohne_etappe` wird gezeigt, auch wenn es null ist: op ohne Strategie sind zulaessig,
 *    aber wer sie nicht sieht, haelt die Oberflaeche fuer vollstaendig. */
function BM3Strategie({ selectedK }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [offen, setOffen] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_strategie.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const ks = (d.strategien || []).filter(s => !selectedK || selectedK[s.campaign]);
  const lauf = t => t === null ? '' : t < 0 ? `startet in ${-t} Tagen` : `läuft seit ${t} Tagen`;

  return (
    <div>
      {d.hinweis && <div className="gk-note">{d.hinweis}</div>}

      {ks.length === 0 && (
        <div className="gk-placeholder">
          Keine Strategie für die gewählten Kampagnen. Das ist ein Ergebnis, kein Mangel —
          dann wird ohne Strategie geprueft.
        </div>
      )}

      {ks.map(s => (
        <div key={s.strat_id} className="gk-detail" style={{ marginBottom: '1.4rem' }}>
          <div className="gk-grouphead">
            {s.campaign} · {s.name}
            {/* Status ist der Lebenszyklus, Lage das Urteil der Messung - zwei Achsen,
                zwei Marken. Eine ks kann abgebrochen UND noch_offen sein. */}
            <span className="gk-badge" style={{ marginLeft: '.6rem' }}>{s.status}</span>
            {s.lage && <span className="gk-badge" style={{ marginLeft: '.3rem' }}>{s.lage}</span>}
            <span className="gk-muted" style={{ marginLeft: '.6rem', fontWeight: 400 }}>
              ab {s.start} {lauf(s.tage_seit_start) && `· ${lauf(s.tage_seit_start)}`}
              {s.ende && ` · beendet ${s.ende}`}
            </span>
          </div>

          <div style={{ display: 'flex', gap: '1.2rem', flexWrap: 'wrap', margin: '.5rem 0' }}>
            <span><strong>{s.ja}</strong> eingetreten</span>
            <span><strong>{s.nein}</strong> verfehlt</span>
            <span><strong>{s.offen}</strong> offen</span>
          </div>

          {/* 🔴 DAS ZIEL ENTSTEHT AUS FELDERN, nicht aus Fliesstext (Georg 2026-10-19).
              Die vier Angaben: Kennzahl - Richtung - Zielwert - Fenster. `zielwert === null`
              heisst AUSDRUECKLICH "die Richtung genuegt", nicht "fehlt" - bei ks 2 traegt
              jedes der sieben Keywords sein eigenes Soll im wirkhand. */}
          <p style={{ margin: '.4rem 0' }}>
            <strong>Ziel:</strong> {s.kennzahl || '—'} {s.richtung}
            {s.zielwert === null ? ' — die Richtung genügt' : ` auf ${s.zielwert}`}
            {s.verfehlt_unter !== null && `, verfehlt unter ${s.verfehlt_unter}`}
            {s.fenster && ` · je ${s.fenster}`}
            {s.zielbezug && <span className="gk-badge" style={{ marginLeft: '.5rem' }}>{s.zielbezug}</span>}
          </p>
          {s.abbruch_art && <p style={{ margin: '.4rem 0' }}>
            <strong>Abbruch:</strong> {s.abbruch_art} {s.abbruch_wert}</p>}
          {s.bemerkung && <p className="gk-muted" style={{ margin: '.4rem 0' }}>{s.bemerkung}</p>}
          {s.schluss && <p style={{ margin: '.4rem 0' }}><strong>Schluss:</strong> {s.schluss}</p>}

          {(s.etappen || []).map(e => (
            <div key={e.etap_id} style={{ marginTop: '.8rem', paddingLeft: '.8rem',
                                          borderLeft: '3px solid #d0d7de' }}>
              <button className="gk-head" style={{ padding: '.3rem 0' }}
                      onClick={() => setOffen(o => ({ ...o, [e.etap_id]: !o[e.etap_id] }))}
                      aria-expanded={!!offen[e.etap_id]}>
                <span className="gk-caret">{offen[e.etap_id] ? '▾' : '▸'}</span>
                <span style={{ marginLeft: '.4rem' }}>
                  Etappe {e.nr} · {e.name}
                  {e.kp_stufe && <span className="gk-badge" style={{ marginLeft: '.5rem' }}>{e.kp_stufe}</span>}
                  <span className="gk-badge" style={{ marginLeft: '.3rem' }}>{e.status}</span>
                  {e.lage && <span className="gk-badge" style={{ marginLeft: '.3rem' }}>{e.lage}</span>}
                </span>
              </button>

              {/* 🔴 Die Zählung steht UNTER dem Knopf, nicht darin. Im Knopf lief sie am
                  2026-10-19 bei 1280 px über den rechten Rand - `gk-head` ist ein Flex
                  mit space-between, und ein dritter Teil hat dort keinen Platz. Gesehen
                  im Renderlauf nach cdr-2, nicht im Code. */}
              <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap',
                            margin: '.2rem 0 .4rem .4rem', fontSize: '.92em' }}>
                <span>{e.op_zahl} op</span>
                <span>{e.ja} eingetreten</span>
                <span>{e.nein} verfehlt</span>
                <span>{e.offen} offen</span>
              </div>

              {offen[e.etap_id] && (
                <div style={{ marginTop: '.4rem' }}>
                  {e.erwartung && <p style={{ margin: '.3rem 0' }}>
                    <strong>Erwartung:</strong> {e.erwartung}</p>}
                  <div className="gk-tablewrap">
                    <table className="gk-table">
                      <thead>
                        <tr>
                          <th>op</th><th>Stufe</th><th>Ursache</th><th>Handlung</th>
                          <th>H-Datum</th><th>Prüfung</th><th>eingetreten</th>
                        </tr>
                      </thead>
                      <tbody>
                        {e.handlungen.map(h => (
                          <tr key={h.id}>
                            <td>{h.id}</td>
                            <td>{h.kp_stufe || '—'}</td>
                            <td title={h.ursache_text}>{h.ursache_code || '—'}</td>
                            <td title={h.handlung_text}>{h.handlung_code || '—'}</td>
                            <td className="gk-nowrap">{h.h_datum || '—'}</td>
                            <td className="gk-nowrap">{h.pruef_datum || '—'}</td>
                            <td>{h.eingetreten === null ? 'offen'
                                 : h.eingetreten === 1 ? 'ja' : 'nein'}</td>
                          </tr>
                        ))}
                        {e.handlungen.length === 0 && (
                          <tr><td colSpan={7} className="gk-muted">noch keine Handlung</td></tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ))}

          {(s.etappen || []).length === 0 && (
            <div className="gk-placeholder">noch keine Etappe</div>
          )}
        </div>
      ))}

      <p className="gk-muted" style={{ marginTop: '1rem' }}>
        {d.ohne_etappe} Prozess-Satz/Sätze gehören zu keiner Strategie — zulässig, aber
        sie zählen in keiner ks mit. Stand {d.generated}.
      </p>
    </div>
  );
}

function BM2Hist({ selectedK }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [openK, setOpenK] = useState({});
  const [busy, setBusy] = useState(0);
  const [zoMeld, setZoMeld] = useState('');
  const [nurOffen, setNurOffen] = useState(true);

  const laden = () => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_hist.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  };
  useEffect(laden, []);

  /* 🔴 EINEM op SEINE ETAPPE ZUORDNEN (Georg 2026-10-19: "Ich muss einen op Objekt
     einen Strategie Etappen Punkt zuordnen koennen" - und zwar hier, wo die Handlung
     steht). Der Endpunkt setzt GENAU dieses eine Feld und weist ab, was nicht passt:
     eine beendete ks, eine fremde Kampagne, ein H-Datum vor dem ks-Start.
     ⚠ Die Meldung des Servers wird GEZEIGT, nicht verschluckt - sonst sieht ein
     abgewiesener Schreibversuch wie ein erfolgreicher aus. */
  const zuordnen = (opId, etapId) => {
    const token = localStorage.getItem('token') || '';
    setBusy(opId); setZoMeld('');
    fetch(`${API_BASE}/gads_op_etappe.php`, {
      method: 'POST',
      headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: opId, etap_id: etapId === '' ? null : Number(etapId) }),
    })
      .then(r => r.json())
      .then(j => {
        setBusy(0);
        if (!j.success) { setZoMeld('op ' + opId + ': ' + (j.message || 'Fehler')); return; }
        if (j.unveraendert) { setZoMeld('op ' + opId + ': keine Änderung'); return; }
        setZoMeld('op ' + opId + ' → ' + (j.strat_name || 'keiner Strategie')
                  + ' · noch ohne Etappe: ' + j.ohne_etappe);
        laden();
      })
      .catch(e => { setBusy(0); setZoMeld(String(e)); });
  };

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const an = r => !selectedK || selectedK[r.campaign];
  const z = d.zahlen || {};
  const ketten = (d.ketten || []).filter(an);
  const wechsel = (d.wechsel || []).filter(an);
  const prog = (d.prognosen || []).filter(an);

  // Die Fassungen je Kette gruppieren — eine Kette, ihre Fassungen untereinander.
  const perKette = {};
  wechsel.forEach(w => { (perKette[w.hist_id] = perKette[w.hist_id] || []).push(w); });
  const kettenIds = Object.keys(perKette);

  // Ketten je Art zusammenfassen, Status als Spalten.
  const perArt = {};
  ketten.forEach(k => {
    const s = (perArt[k.art] = perArt[k.art] || { art: k.art, klasse: k.klasse, aktiv: 0, pausiert: 0, entfernt: 0, n: 0 });
    s[k.status] = (s[k.status] || 0) + k.n;
    s.n += k.n;
  });
  const arten = Object.values(perArt).sort((a, b) => b.n - a.n);

  const toggleK = k => setOpenK(o => ({ ...o, [k]: !o[k] }));

  /* Die op dieses Panels: ALLE, nicht nur die zugeordneten - der Korb der
     unzugeordneten ist der Zweck, und er soll sich sichtbar leeren. */
  const opAlle = (d.op || []).filter(an);
  const opListe = nurOffen ? opAlle.filter(o => o.etap_id === null) : opAlle;
  const wahl = d.etappen_wahl || [];

  return (
    <>
    {/* ---- Die Zahlen, die alles andere tragen ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>{z.ketten} Ketten</strong> — {z.aktiv} aktiv · {z.pausiert} pausiert
      {z.entfernt ? ` · ${z.entfernt} entfernt` : ''} ·&nbsp;
      <strong>{z.fassungen} Fassungen</strong> über {z.ketten_mit_fassung} Ketten,
      {' '}{z.ketten_ohne_fassung} Ketten ohne ·&nbsp;
      <strong>{z.wechsel_ketten} mit Fassungswechsel</strong> ·&nbsp;
      <strong>Prognosen {z.quote_text}</strong>, {z.mit_pruefdatum} mit Prüfdatum
      {' '}von {z.prozess_saetze} Prozess-Sätzen
      {z.saetze_verschoben ? ` · ${z.saetze_verschoben} verschoben (je Satz höchstens einmal)` : ''}
      {' '}· Stand {d.generated}
    </span></div>

    {/* ---- Block 1: die Ketten je Art ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>① Die Ketten</strong> — ein lebenslanger Schlüssel je Objekt. Die Klasse sagt,
      ob das Objekt einen Anker hat, frei ist oder an einem Platz hängt.
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Art</th><th>Klasse</th><th className="r">aktiv</th><th className="r">pausiert</th>
          <th className="r">entfernt</th><th className="r">zusammen</th>
        </tr></thead>
        <tbody>
          {arten.map(a => (
            <tr key={a.art}>
              <td><strong>{a.art}</strong></td>
              <td>{a.klasse}</td>
              <td className="r">{a.aktiv || '—'}</td>
              <td className="r">{a.pausiert || '—'}</td>
              <td className="r">{a.entfernt || '—'}</td>
              <td className="r"><strong>{a.n}</strong></td>
            </tr>
          ))}
          {!arten.length && <tr><td colSpan="6">keine Kampagne ausgewählt</td></tr>}
        </tbody>
      </table>
    </div>

    {/* ---- Block 2: die Fassungswechsel ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>② Die Fassungswechsel</strong> — hier hat sich ein Objekt geändert und die Kette
      gehalten. Genau dafür gibt es die Hist-ID. Zeile anklicken für die Fassungen.
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Hist-ID</th><th>K</th><th>Art</th><th>Anker</th>
          <th className="r">Fassungen</th><th>Status</th>
        </tr></thead>
        <tbody>
          {kettenIds.map(id => {
            const f = perKette[id];
            const k = f[0];
            const isOpen = !!openK[id];
            return (
              <React.Fragment key={id}>
                <tr className="gk-grouphead" onClick={() => toggleK(id)}>
                  <td><span className="gk-caret">{isOpen ? '▾' : '▸'}</span> <strong>{id}</strong></td>
                  <td>{k.campaign}</td>
                  <td>{k.art}</td>
                  <td>{k.anker || '—'}</td>
                  <td className="r">{k.fassungen}</td>
                  <td>{k.status}</td>
                </tr>
                {isOpen && f.map((x, i) => (
                  <tr key={i}>
                    <td></td>
                    <td colSpan="5">
                      <small>
                        {x.gueltig_ab || '?'} bis {x.gueltig_bis || 'offen'}
                        {x.match_type ? ` · ${x.match_type}` : ''}
                        {x.feld ? ` · ${x.feld}` : ''}
                        {x.inhalt ? ` · ${x.inhalt}` : ''}
                      </small>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
          {!kettenIds.length && <tr><td colSpan="6">kein Fassungswechsel in der Auswahl</td></tr>}
        </tbody>
      </table>
    </div>

    {/* ---- Block 3: die Prognosen auf Objektebene ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>③ Die Prognosen am Objekt</strong> — aus den Prozess-Sätzen. Seit dem 29.10.
      misst der Richter <code>gads_prognose_check.php</code> das Wochenwachstum: die volle
      Woche vor der Woche mit dem H-Datum gegen die Woche (Fr–Do), die vor dem Prüfdatum
      endet. Ab 20 Prozent ist die Prognose <em>eingetreten</em>. Darunter geht das
      Prüfdatum genau einmal eine Woche weiter; bleibt es dann unter 20 Prozent, ist sie
      nicht eingetreten. H-Datum und Prüfdatum fallen auf einen Freitag.
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>Hist-ID</th><th>K</th><th>Objekt</th><th>Erwartung</th>
          <th>Art</th><th>H-Datum</th><th>Prüftag</th><th>Urteil</th><th className="r">Abstand</th>
        </tr></thead>
        <tbody>
          {prog.map(p => (
            <tr key={p.id} className={p.faellig && p.eingetreten === null ? 'gk-warn' : ''}>
              <td>{p.hist_id ?? '—'}</td>
              <td>{p.campaign}</td>
              <td><small>{p.objekt}</small></td>
              <td><small>{p.wirkhand || '—'}</small></td>
              <td><small>{p.art_prognose}</small></td>
              <td>{p.h_datum || '—'}</td>
              <td>{p.pruef_datum}{p.faellig ? ' ⚠' : ''}</td>
              <td>{p.eingetreten === null ? (p.faellig ? 'FÄLLIG, nicht beurteilt' : 'offen')
                   : p.eingetreten ? 'getroffen' : 'verfehlt'}</td>
              <td className="r">{p.abstand ?? '—'}</td>
            </tr>
          ))}
          {!prog.length && <tr><td colSpan="9">keine Prognose in der Auswahl</td></tr>}
        </tbody>
      </table>
    </div>


    {/* ---- Block 4: die Handlungen und ihre Strategie ----
         WOZU (Georg 2026-10-19): "wenn ich B09 oeffne sehe ich keinen Hinweis auf
         irgendwelche op" - und die op koennen in jedem Panel und jeder Wochenzeile
         sitzen. Hier stehen ALLE an einem Ort, mit der Strategie dahinter.
         🔴 Der Korb der unzugeordneten ist der Zweck: er soll sich sichtbar leeren. */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>④ Die Handlungen und ihre Strategie</strong> — alle Prozess-Sätze an einem
      Ort, quer über die Panels. Ein op ohne Etappe zählt in keiner Strategie mit; das ist
      zulässig, aber sichtbar. Zugeordnet wird hier, wo die Handlung steht.
      {' '}Der Schreibweg weist ab, was nicht passt: eine beendete ks, eine fremde
      Kampagne, oder ein H-Datum <em>vor</em> dem Start der Strategie.
    </span></div>

    <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', margin: '.4rem 0' }}>
      <label style={{ display: 'flex', gap: '.4rem', alignItems: 'center' }}>
        <input type="checkbox" checked={nurOffen} onChange={e => setNurOffen(e.target.checked)} />
        nur die ohne Etappe
      </label>
      <span className="gk-muted">
        {d.op_ohne_etappe} von {(d.op || []).length} ohne Etappe
      </span>
      {zoMeld && <span className="gk-note" style={{ padding: '.2rem .5rem' }}>{zoMeld}</span>}
    </div>

    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th>op</th><th>Panel</th><th>K</th><th>Objekt</th><th>Stufe</th>
            <th>Ursache</th><th>Handlung</th><th>H-Datum</th><th>Prüfung</th>
            <th>eingetreten</th><th>Strategie · Etappe</th>
          </tr>
        </thead>
        <tbody>
          {opListe.map(o => (
            <tr key={o.id}>
              <td>{o.id}</td>
              <td>{o.bericht}</td>
              <td>{o.campaign}</td>
              <td title={o.objekt}>{(o.objekt || '').slice(0, 30)}</td>
              <td>{o.kp_stufe || '—'}</td>
              <td>{o.ursache_code || '—'}</td>
              <td>{o.handlung_code || '—'}</td>
              <td className="gk-nowrap">{o.h_datum || '—'}</td>
              <td className="gk-nowrap">
                {o.pruef_datum || '—'}{o.verschoben === 1 && ' ·v'}
              </td>
              <td>{o.eingetreten === null ? 'offen' : o.eingetreten === 1 ? 'ja' : 'nein'}</td>
              <td>
                <select value={o.etap_id === null ? '' : String(o.etap_id)}
                        disabled={busy === o.id}
                        onChange={e => zuordnen(o.id, e.target.value)}
                        style={{ maxWidth: '20rem' }}>
                  <option value="">— keiner Strategie —</option>
                  {wahl.map(w => (
                    <option key={w.etap_id} value={w.etap_id}>
                      {w.campaign} · {w.strat_name} · Etappe {w.nr} ({w.kp_stufe})
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
          {!opListe.length && (
            <tr><td colSpan="11">
              {nurOffen ? 'jeder Prozess-Satz hängt an einer Etappe'
                        : 'kein Prozess-Satz in der Auswahl'}
            </td></tr>
          )}
        </tbody>
      </table>
    </div>

    {/* 🔴 DIE KAMPAGNEN-PROGNOSEN SIND RAUS (Georg 2026-10-16: "die prognosen kommen raus die haben uns
        schon viel zu viel Zeit gekostet"). Er zeigte die Kampagnenebene aus
        `ads_prognosen` - die Tabelle wurde am 2026-10-15 geloescht, und die Abfrage
        dazu in `gads_kpi_hist.php` liess das GANZE Panel als "DB-Fehler" enden, auch
        die Bloecke 1 bis 3. Die Hist-Daten stehen in Block 3. */}
    </>
  );
}

// ---------- B-1 · Markt ----------
// Der Kopfteil über allen Berichten: Suchraum (ads_suchraum), Gebotsband-Prognose
// (ads_suchraum_prognose) und der eigene Stand im Markt (ads_kpi_b01). Beantwortet,
// OB Arbeit an den Objekten tragen kann, bevor man sie beginnt.
function B00Markt({ selectedK }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [openB, setOpenB] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_markt.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setD(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!d) return <div className="gk-placeholder">lädt…</div>;

  const an = r => !selectedK || selectedK[r.campaign];
  const markt = d.markt.filter(an);
  const band = d.band.filter(an);
  const stand = d.stand.filter(an);
  if (!markt.length && !band.length && !stand.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const toggleB = k => setOpenB(o => ({ ...o, [k]: !o[k] }));

  const stufen = (d.stufen || []).filter(s => !selectedK || selectedK[s.campaign]);
  const AMPEL = { gruen: '#1a7f37', rot: '#b3261e', ungeprueft: '#8a6d00', nicht_hier: '#9aa0a6' };
  const AMPEL_TEXT = { gruen: 'grün', rot: 'ROT', ungeprueft: 'ungeprüft', nicht_hier: 'nicht hier' };

  return (
    <>
    {/* ---- Block 0: die Stufen-Ampel (2026-10-19) ---- */}
    {/* Die Wirkungskette aus dem kp-Konzept. Der Zaun: an der ERSTEN roten Stufe wird
        gearbeitet, alles darunter ist bedeutungslos, solange sie rot ist. Die Schwellen
        stehen in api/gads_kpi_markt.php, nicht hier - eine Stelle, eine Definition. */}
    {stufen.length > 0 && (
      <>
      <div className="gk-toolbar"><span className="gk-toolbar-hint">
        <strong>ⓞ Die Stufen</strong> — Markt · Auktion · Impressionen · Klicks · Landung · Ertrag.
        <strong> An der ersten ROTEN Stufe wird gearbeitet</strong>; alles darunter ist
        bedeutungslos, solange sie rot ist. Schwellen: brach &lt; {d.schwellen?.s1_brach_max}% ·
        Anteil &gt; {d.schwellen?.s2_is_min}% · ab {d.schwellen?.s3_impr_min} Impr. ·
        CTR ≥ {d.schwellen?.s4_ctr_min}% · Conv.-Rate ≥ {d.schwellen?.s5_cvr_min}% ·
        ab {d.schwellen?.s6_conv_min} Conv. · Wochenzeile höchstens {d.schwellen?.woche_alt_max} Tage alt
      </span></div>
      <div className="gk-tablewrap">
        <table className="gk-table">
          <thead><tr>
            <th>K</th>
            <th>S1 Markt</th><th>S2 Auktion</th><th>S3 Impr.</th><th>S4 Klick</th>
            <th>S5 Landung</th><th>S6 Ertrag</th><th>SM Markt-Preis</th>
          </tr></thead>
          <tbody>
            {stufen.map(k => {
              const g = s => (k.stufen || []).find(x => x.stufe === s) || {};
              const z = s => {
                const x = g(s);
                return <td key={s} style={{ color: AMPEL[x.lage] || undefined }} title={x.satz || ''}>
                  <strong>{AMPEL_TEXT[x.lage] || '—'}</strong>
                  {x.wert != null ? <><br /><small>{x.wert}{x.schwelle != null ? ` / ${x.schwelle}` : ''}</small></> : null}
                </td>;
              };
              return (
                <React.Fragment key={k.campaign}>
                  <tr>
                    <td><strong>{k.campaign}</strong></td>
                    {['S1','S2','S3','S4','S5','S6','SM'].map(z)}
                  </tr>
                  {/* 🔴 Die Handlungszeile. Sie stand bis zum 2026-10-19 als Spalte
                      „erste rote" da und nannte nur das Kuerzel — Georg: „Mit erste rote
                      kann ich nichts anfangen". Der Text kommt vom Server (`tun`), damit
                      Stufe und Handlung an EINER Stelle definiert sind. */}
                  <tr>
                    <td></td>
                    <td colSpan={7} style={{ color: k.erste_rote ? AMPEL.rot : AMPEL.gruen }}>
                      <strong>{k.erste_rote ? `${k.erste_rote} → ` : ''}{k.tun || 'nichts offen'}</strong>
                    </td>
                  </tr>
                  <tr className="gk-detail">
                    <td></td>
                    <td colSpan={7}><small>{(k.stufen || [])
                      .filter(x => x.lage !== 'nicht_hier')
                      .map(x => `${x.stufe}: ${x.satz}`).join(' · ')}</small></td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <div className="gk-note">
          <strong>S0 Rahmen</strong> (Änderungen der Vorwoche) braucht <code>ads_changes</code>,
          das dieses Panel nicht hat — die Stufe steht als <em>nicht hier</em>, und das ist kein grün.
          Die <strong>Gebotsanpassungen</strong> sind seit dem 2026-10-19 keine eigene Stufe mehr:
          sie sind eine Kostenfrage quer zum Trichter und gehören zu S6 (Panel B06).
          <br /><strong>Die Kette folgt dem Trichter</strong> (Georg 2026-10-19): Markt → Auktion →
          Impressionen → Klicks → Landung → Ertrag. Vorher hieß S3 „Gebote" und S4 „Klick“,
          zeigte aber die Impressionszahl — die Klick-Stufe fehlte ganz.
          Konzept: <code>Kampagnen-Performance/kp-Strategie-vom-Markt-zum-CPA.md</code>
          <br /><strong>SM Markt-Preis steht ZULETZT</strong> — vorher an zweiter Stelle, wo sie
          anschlug, bevor S1 bis S6 geprüft waren. Ihre einzige Antwort lautet „Ziel-CPA anheben
          oder mehr bieten"; als erste Stufe schnitt sie genau die Hebel ab, die nichts kosten.
          <br /><strong>Eine Wochenzeile älter als {d.schwellen?.woche_alt_max} Tage</strong> macht
          die ganze Kette <em>ungeprüft</em>. Ohne diese Grenze empfahl die Ampel am 2026-10-19 für
          SO „Match engen" auf Basis einer Woche von Ende Mai.
          {(d.ruhend || []).length > 0 && (
            <><br /><strong>Ruhend, nicht in der Ampel:</strong>{' '}
              {(d.ruhend || []).map(r => `${r.campaign} (${r.satz})`).join(' · ')}</>
          )}
        </div>
      </div>
      </>
    )}

    {/* ---- Block 1: der Suchraum ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>① Der Markt</strong> — Suchraum aus dem Keyword-Planer, Stand {d.suchraum_stand}. Zeile anklicken für die Begriffe.
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>K</th><th className="r">Begriffe</th><th className="r">Suchen/Monat</th><th className="r">Suchen/Woche</th>
          <th className="r">mit Keyword</th><th className="r">ohne Keyword</th><th className="r">davon Suchen</th>
          <th className="r">brach</th><th>Keyword-Daten bis</th>
        </tr></thead>
        <tbody>
          {markt.map(m => {
            const alt = m.kw_alt != null && m.kw_alt > 10;
            const isOpen = !!openB[m.campaign];
            return (
              <React.Fragment key={m.campaign}>
                <tr className="gk-grouphead" onClick={() => toggleB(m.campaign)}>
                  <td><span className="gk-caret">{isOpen ? '▾' : '▸'}</span> <strong>{m.campaign}</strong></td>
                  <td className="r">{m.begriffe}</td>
                  <td className="r">{num(m.vol)}</td>
                  <td className="r">{num(m.vol_woche)}</td>
                  <td className="r">{m.n_mit}</td>
                  <td className="r">{m.n_ohne}</td>
                  <td className="r">{num(m.vol_ohne)}</td>
                  <td className={'r' + (m.brach_pct >= 50 ? ' gk-warn' : '')}>{pct(m.brach_pct)}</td>
                  <td className={alt ? 'gk-warn' : undefined}>{m.kw_stand || '—'}{alt ? ` · ${m.kw_alt} T alt` : ''}</td>
                </tr>
                {isOpen && d.begriffe.filter(b => b.campaign === m.campaign).map((b, i) => (
                  <tr key={i} className="gk-detail">
                    <td></td>
                    <td colSpan={2}>{b.keyword ? '✓ ' : <span className="gk-warn">✗ </span>}{b.begriff}</td>
                    <td className="r">{num(b.vol)}/Mon</td>
                    <td className="r">{b.woche}/Wo</td>
                    <td colSpan={2}>{b.wettbew || '—'}{b.wettidx != null ? ` (${b.wettidx})` : ''}</td>
                    <td className="r" colSpan={2}>{b.gmin != null ? `Gebot ${eur(b.gmin)} – ${eur(b.gmax)}` : '—'}</td>
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="gk-note">
        „ohne Keyword" heißt: der Planer-Begriff steht als Text in keinem Keyword dieser Kampagne.
        ⚠ Der Abgleich läuft gegen <code>ads_performance_keywords</code>, und die führt nur Keywords, die
        im Zeitraum <em>Daten geliefert</em> haben. Ist die Spalte „Keyword-Daten bis" alt, heißt „brach"
        nur <em>nicht gemessen</em> — nicht <em>nicht belegt</em>.
      </div>
    </div>

    {/* ---- Block 2: das Gebotsband ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>② Das Gebotsband</strong> — Googles eigene Prognose, Stand {d.prognose_stand}
      {band.length ? ` · Fenster ${band[0].fenster}` : ''}
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>K</th><th>Match</th><th className="r">Gebot</th><th className="r">Budget</th><th className="r">Begriffe</th>
          <th className="r">Impr./Wo</th><th className="r">Klicks</th><th className="r">CTR</th>
          <th className="r">Kosten</th><th className="r">Ø CPC</th><th className="r">Conv.</th><th className="r">CPA</th>
        </tr></thead>
        <tbody>
          {band.map((b, i) => (
            <tr key={i}>
              <td><strong>{b.campaign}</strong></td><td>{b.match}</td>
              <td className="r">{eur(b.gebot)}</td><td className="r">{eur(b.budget)}</td><td className="r">{b.begriffe}</td>
              <td className="r">{b.impr}</td><td className="r">{b.klicks}</td><td className="r">{pct(b.ctr)}</td>
              <td className="r">{eur(b.kosten)}</td><td className="r">{eur(b.cpc)}</td>
              <td className="r">{b.conv}</td><td className="r">{eur(b.cpa)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        🔴 <strong>Zwei Lesarten, beide gelten.</strong> Erstens sagt Googles eigene Prognose, was mehr Gebot
        bringt — bei EA wachsen die Impressionen von 10 auf 40 € um 1,6 %, der CPA steigt von 74,62 auf
        86,36 €. Die Handlung „Gebot anheben" ist damit vor jeder Messung fraglich.
        <br />⚠ <strong>Zweitens ist die Prognose nicht mit den Ist-Zahlen vergleichbar</strong> — sie rechnet mit
        <code> ManualCpc</code> und kennt keinen Ziel-CPA, die Kampagne fährt aber MAXIMIZE_CONVERSIONS.
        Für EA nennt sie 14,2 Impressionen je Woche, gemessen wurden 71. <strong>Die Richtung gilt, die Höhe nicht.</strong>
      </div>
    </div>

    {/* ---- Block 3: wo wir stehen ---- */}
    <div className="gk-toolbar"><span className="gk-toolbar-hint">
      <strong>③ Wo wir im Markt stehen</strong> — aus B01, jüngste Woche und Vorwoche
    </span></div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead><tr>
          <th>K</th><th>Zeitraum</th><th className="r">Impr.</th><th className="r">möglich</th><th className="r">Anteil</th>
          <th className="r">am Rang verloren</th><th className="r">am Budget verloren</th>
          <th className="r">Klicks</th><th className="r">CTR</th><th className="r">Conv.</th>
          <th className="r">Kosten</th><th className="r">CPA</th><th className="r">Ziel-CPA</th><th>Strategie</th>
        </tr></thead>
        <tbody>
          {stand.map((s, i) => (
            <tr key={i} className={s.rang === 2 ? 'gk-detail' : undefined}>
              <td>{s.rang === 1 ? <strong>{s.campaign}</strong> : ''}</td>
              <td className="gk-nowrap" style={{ fontWeight: 400 }}>{s.zeitraum}</td>
              <td className="r">{num(s.impr)}</td>
              <td className="r"><strong>{s.moeglich == null ? '—' : num(s.moeglich)}</strong></td>
              <td className="r">{pct(s.is)}</td>
              <td className={'r' + (s.lost_rang >= 50 ? ' gk-warn' : '')}>{pct(s.lost_rang)}</td>
              <td className={'r' + (s.lost_bud > 0 ? ' gk-warn' : '')}>{pct(s.lost_bud)}</td>
              <td className="r">{num(s.clicks)}</td><td className="r">{pct(s.ctr)}</td><td className="r">{num(s.conv)}</td>
              <td className="r">{eur(s.costs)}</td><td className="r">{eur(s.cpa)}</td>
              <td className="r">{s.ziel_cpa == null ? '—' : eur(s.ziel_cpa)}</td>
              <td className="gk-muted2">{s.strategie}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="gk-note">
        <strong>möglich</strong> = Impressionen ÷ Impression-Share — der Markt, den wir in dieser Woche
        hätten sehen können. Was fehlt, ging entweder <strong>an den Rang</strong> (Gebot × Qualitätsfaktor zu
        niedrig) oder <strong>ans Budget</strong>.
        <br />⚠ <strong>Steht „am Budget verloren" auf 0,00 %, kauft mehr Budget keine einzige Impression</strong> —
        das schneidet die Handlung „Budget erhöhen" ab, solange der Wert dort steht. Bei EA war er in allen
        acht gemessenen Wochen 0,00 %. Stand: {d.generated}.
      </div>
    </div>
    </>
  );
}

// ---------- B00 · Änderungen ----------
// Eine Zeile je Änderungsereignis aus ads_changes, eingeordnet in dieselben Perioden
// wie B01–B14. Eigene Komponente statt GroupedReport, weil eine Änderung weder Kosten
// noch Impressionen hat — GroupedReport ist fest auf diese Kennzahlen verdrahtet.
const B00_ARTEN = ['Strategie', 'Gebot/Budget', 'Negatives', 'Keywords', 'Assets/Anzeigen', 'Status/Struktur', 'Sonstiges'];

function BM1Aenderungen({ selectedK }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [openG, setOpenG] = useState({});
  const [art, setArt] = useState({});          // leer = alle Arten

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_aenderungen.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setData(j); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!data) return <div className="gk-placeholder">lädt…</div>;

  const artAn = B00_ARTEN.filter(a => art[a]);
  const shown = data.rows.filter(r => (!selectedK || selectedK[r.campaign]) && (!artAn.length || art[r.art]));
  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}|${r.zeit}|${r.was}`;

  // Gruppieren nach (Typ × Zeitraum × Kampagne) — Reihenfolge aus der sortierten Liste
  const groups = []; const gmap = {};
  shown.forEach(r => {
    const gk = `${r.typ}|${r.zeitraum}|${r.campaign}`;
    if (!gmap[gk]) { gmap[gk] = { key: gk, typ: r.typ, zeitraum: r.zeitraum, campaign: r.campaign, rows: [] }; groups.push(gmap[gk]); }
    gmap[gk].rows.push(r);
  });

  const toggleG = k => setOpenG(o => ({ ...o, [k]: !o[k] }));
  const setAllG = v => setOpenG(v ? Object.fromEntries(groups.map(g => [g.key, true])) : {});
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const groupChecked = g => g.rows.every(r => sel[rowKey(r)]);
  const toggleGroupSel = g => { const v = !groupChecked(g); setSel(s => { const n = { ...s }; g.rows.forEach(r => { n[rowKey(r)] = v; }); return n; }); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;
  const toggleArt = a => setArt(s => ({ ...s, [a]: !s[a] }));

  // Was in dieser Woche geschah, in einem Halbsatz — die Arten mit Anzahl
  const artMix = g => {
    const z = {}; g.rows.forEach(r => { z[r.art] = (z[r.art] || 0) + 1; });
    return B00_ARTEN.filter(a => z[a]).map(a => `${a} ${z[a]}`).join(' · ');
  };
  const hatStrategie = g => g.rows.some(r => r.art === 'Strategie');

  const exportCsv = () => {
    const cols = [['Typ', 'typ'], ['Zeitraum', 'zeitraum'], ['Kampagne', 'campaign'], ['Zeit', 'zeit'],
                  ['Art', 'art'], ['Anzeigengruppe', 'azg'], ['Nutzer', 'nutzer'], ['Änderung', 'was']];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => { const v = r[c[1]]; if (v == null) return ''; const s = String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'gads_b00_aenderungen.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <button className="gk-kbtn" onClick={() => setAllG(true)}>Alle auf</button>
      <button className="gk-kbtn" onClick={() => setAllG(false)}>Alle zu</button>
      <span className="gk-toolbar-hint">{groups.length} Gruppen · {shown.length} Änderungen</span>
    </div>
    <div className="gk-toolbar">
      <span className="gk-toolbar-hint">Art:</span>
      {B00_ARTEN.map(a => (
        <button key={a} className={'gk-kbtn' + (art[a] ? ' on' : '')} onClick={() => toggleArt(a)}>{a}</button>
      ))}
      {artAn.length > 0 && <button className="gk-kbtn" onClick={() => setArt({})}>Filter aus</button>}
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"></th>
            <th>Typ</th><th>Zeitraum</th><th>K</th>
            <th>Zeit</th><th>Art</th><th>Anzeigengruppe</th><th>Nutzer</th><th>Änderung</th>
          </tr>
        </thead>
        <tbody>
          {groups.map(g => {
            const isOpen = !!openG[g.key];
            return (
              <React.Fragment key={g.key}>
                <tr className="gk-grouphead" onClick={() => toggleG(g.key)}>
                  <td className="gk-chkcol" onClick={e => e.stopPropagation()}><input type="checkbox" checked={groupChecked(g)} onChange={() => toggleGroupSel(g)} title="Gruppe wählen" /></td>
                  <td className="gk-nowrap"><span className="gk-caret">{isOpen ? '▾' : '▸'}</span> <span className={'gk-badge ' + (g.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{g.typ}</span></td>
                  <td className="gk-nowrap" style={{ fontWeight: 400 }}>{g.zeitraum}</td>
                  <td><strong>{g.campaign}</strong></td>
                  <td className="gk-muted2">{g.rows.length} Änd.</td>
                  <td className="gk-muted2" colSpan={4}>
                    {hatStrategie(g) && <strong className="gk-warn">⚠ Strategie-Wechsel · </strong>}
                    {artMix(g)}
                  </td>
                </tr>
                {isOpen && g.rows.map((r, i) => (
                  <tr key={i} className={'gk-detail' + (sel[rowKey(r)] ? ' gk-selected' : '')}>
                    <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
                    <td></td><td></td><td></td>
                    <td className="gk-nowrap">{r.zeit}</td>
                    <td className="gk-nowrap">{r.art === 'Strategie' ? <strong className="gk-warn">{r.art}</strong> : r.art}</td>
                    <td className="gk-nowrap">{r.azg || '—'}</td>
                    <td className="gk-nowrap">{r.nutzer || '—'}</td>
                    <td>{r.was}</td>
                  </tr>
                ))}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="gk-note">
        Änderungsverlauf aus <code>ads_changes</code> (GAds-API-Sync + CSV-Import), eingeordnet in dieselben
        Perioden wie B01–B14 — jede Änderung erscheint in ihrer Woche <em>und</em> in ihrem Monat,
        die Wochensumme ist also gleich der Monatssumme.
        Grundmenge: {data.quelle} verschiedene Ereignisse; <strong>{data.ohne_k} ohne Kampagnenzuordnung</strong> (nicht
        in der Tabelle, Google liefert dort keine campaign_id).
        {data.laufend > 0 && <> <strong>{data.laufend}</strong> Änderungen liegen in der noch <strong>laufenden</strong> Woche,
        die B01–B14 nicht kennen — dort sind nur abgeschlossene Perioden angelegt; sie ist hier mit
        „· laufend" gekennzeichnet.</>}
        <br />⚠ <strong>Strategie-Wechsel setzt die Lernphase zurück</strong> — steigende Kosten in der Folgewoche sind dann
        oft hausgemacht und kein Marktsignal. Stand: {data.generated}.
      </div>
    </div>
    </>
  );
}

// ---------- B01 · Kampagne ----------
function B01Kampagne({ selectedK }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [saetze, prozessNeuLaden] = useProzess('b01');
  const [offenP, setOffenP] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_b01.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setRows(j.rows); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!rows) return <div className="gk-placeholder">lädt…</div>;
  const shown = rows.filter(r => !selectedK || selectedK[r.campaign]);
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}`;
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const allChecked = shown.every(r => sel[rowKey(r)]);
  const toggleAll = () => { const v = !allChecked; const n = { ...sel }; shown.forEach(r => { n[rowKey(r)] = v; }); setSel(n); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;

  const exportCsv = () => {
    const cols = [
      ['Typ', 'typ', 0], ['Zeitraum', 'zeitraum', 0], ['Kampagne', 'campaign', 0],
      ['Kosten', 'costs', 1], ['Impressionen', 'impr', 1], ['Klicks', 'clicks', 1], ['CTR %', 'ctr', 1], ['Ø CPC', 'cpc', 1],
      ['Conversions', 'conv', 1], ['Kosten/Conv.', 'cpa', 1], ['Conv.-Rate %', 'convrate', 1],
      ['Impr. oberste %', 'oberste', 1], ['Impr. obere %', 'obere', 1], ['IS %', 'is', 1], ['Lost Rang %', 'lost_rang', 1], ['Lost Budget %', 'lost_budget', 1],
      ['Aktive Keywords', 'active_keywords', 1], ['Strategie', 'strat', 0], ['Budget', 'budget', 1],
    ];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => { const v = r[c[1]]; if (v == null) return ''; const s = c[2] ? String(v).replace('.', ',') : String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s; };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'gads_b01.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <span className="gk-toolbar-hint">Zeilen links per Checkbox wählen</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"><input type="checkbox" checked={allChecked} onChange={toggleAll} title="alle" /></th>
            <th title="Ursache · Handlung · WirkHand · Prüfung">Prozess</th>
            <th>Typ</th><th>Zeitraum</th><th>K</th>
            <th className="r">Kosten</th><th className="r">Impr.</th><th className="r">Klicks</th>
            <th className="r">CTR</th><th className="r">Ø CPC</th><th className="r">Conv.</th>
            <th className="r">Kosten/Conv.</th><th className="r">Conv.-Rate</th>
            <th className="r">oberste %</th><th className="r">obere %</th>
            <th className="r">IS</th><th className="r">Lost Rang</th><th className="r">Lost Budget</th>
            <th className="r">akt. KW</th><th>Strategie</th><th className="r">Budget</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((r, i) => {
            /* 🔴 DER OBJEKTNAME IST DER KAMPAGNENNAME, nicht das Wort 'Kampagne'
               (gads_hist_id.php Z. 61: 'Der Anker IST der Kampagnenname - das
               Dashboard fuehrt ihn in b01 als Objektnamen'). Bis zum 2026-10-19
               stand hier das feste Wort, und B01 fand seine eigenen Prozess-Saetze
               nicht: zwei lagen unsichtbar in der Tabelle. Gefunden hat es Georg.
               ⚠ Fallback auf das Kuerzel, falls ein aelterer Endpunkt kein
               campaign_name liefert - dann greift der Schluessel zwar nicht, aber
               das Panel bricht nicht. */
            const pk = prozessKey(r, r.campaign_name || r.campaign);
            const ps = saetze[pk];
            const pAuf = !!offenP[pk];
            return (
            <React.Fragment key={i}>
            <tr className={(r.typ === 'Monat' ? 'gk-monat' : '') + (sel[rowKey(r)] ? ' gk-selected' : '')}>
              <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
              <td className="gk-nowrap">
                <button className={'gk-kbtn gp-knopf' + (ps ? ' on' : '')}
                        onClick={() => setOffenP(o => ({ ...o, [pk]: !o[pk] }))}
                        title={ps ? `zuletzt gespeichert ${ps.erstellt}` : 'noch kein Satz'}>
                  {pAuf ? '▾ zu' : '✎'} {!pAuf && prozessStand(ps)}
                </button>
              </td>
              <td><span className={'gk-badge ' + (r.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{r.typ}</span></td>
              <td className="gk-nowrap">{r.zeitraum}</td>
              <td><strong>{r.campaign}</strong></td>
              <td className="r">{eur(r.costs)}</td>
              <td className="r">{num(r.impr)}</td>
              <td className="r">{num(r.clicks)}</td>
              <td className="r">{pct(r.ctr)}</td>
              <td className="r">{eur(r.cpc)}</td>
              <td className="r">{num(r.conv)}</td>
              <td className="r">{eur(r.cpa)}</td>
              <td className="r">{pct(r.convrate)}</td>
              <td className="r">{pct(r.oberste)}</td>
              <td className="r">{pct(r.obere)}</td>
              <td className="r">{pct(r.is)}</td>
              <td className="r">{pct(r.lost_rang)}</td>
              <td className="r">{pct(r.lost_budget)}</td>
              <td className="r">{num(r.active_keywords)}</td>
              <td className="gk-nowrap">{r.strat}</td>
              <td className="r">{eur(r.budget)}</td>
            </tr>
            {pAuf && (
              <tr className="gk-detail">
                <td></td>
                {/* Das Objekt ist der KAMPAGNENNAME, wie im Lese-Schlüssel oben. Mit
                    dem festen Wort 'Kampagne' fand gads_hist_id.php den Anker nicht,
                    und der Satz wäre ohne hist_id geblieben. */}
                <ProzessZeile
                  bericht="b01"
                  schluessel={{ campaign: r.campaign, periode_typ: r.typ, periode: r.zeitraum, objekt: r.campaign_name || r.campaign }}
                  satz={ps}
                  gebotIst={undefined}
                  geoId={undefined}
                  onGespeichert={prozessNeuLaden}
                  spalten={20}
                />
              </tr>
            )}
            </React.Fragment>
          );})}
        </tbody>
      </table>
      <div className="gk-note">Alle Werte direkt via GAds-API pro Zeitraum gezogen (ads_kpi_b01) — CSV-verifiziert exakt, inkl. oberste/obere % + aktive Keywords.</div>
    </div>
    </>
  );
}

// ---------- B02 · Auktionen (eigene Position) ----------
function B02Auktionen({ selectedK }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [saetze, prozessNeuLaden] = useProzess('b02');
  const [offenP, setOffenP] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_b02.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setRows(j.rows); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!rows) return <div className="gk-placeholder">lädt…</div>;
  const shown = rows.filter(r => !selectedK || selectedK[r.campaign]);
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}`;
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const allChecked = shown.every(r => sel[rowKey(r)]);
  const toggleAll = () => { const v = !allChecked; const n = { ...sel }; shown.forEach(r => { n[rowKey(r)] = v; }); setSel(n); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;

  const exportCsv = () => {
    const cols = [
      ['Typ', 'typ', 0], ['Zeitraum', 'zeitraum', 0], ['Kampagne', 'campaign', 0], ['Impressionen', 'impr', 1],
      ['IS %', 'is', 1], ['Lost Rang %', 'lost_rang', 1], ['Lost Budget %', 'lost_budget', 1],
    ];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => {
      if (c[1] === 'is' && r.masked) return '< 10'; // Googles Maske ehrlich mit ausgeben
      const v = r[c[1]]; if (v == null) return ''; const s = c[2] ? String(v).replace('.', ',') : String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'gads_b02_auktionen.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <span className="gk-toolbar-hint">Nur eigene Auktions-Position (IS-Bilanz) — Zeilen links wählen</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"><input type="checkbox" checked={allChecked} onChange={toggleAll} title="alle" /></th>
            <th title="Ursache · Handlung · WirkHand · Prüfung">Prozess</th>
            <th>Typ</th><th>Zeitraum</th><th>K</th>
            <th className="r">Impr.</th>
            <th className="r">IS</th><th className="r">Lost Rang</th><th className="r">Lost Budget</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((r, i) => {
            const pk = prozessKey(r, r.domain || 'eigen');
            const ps = saetze[pk];
            const pAuf = !!offenP[pk];
            return (
            <React.Fragment key={i}>
            <tr className={(r.typ === 'Monat' ? 'gk-monat' : '') + (sel[rowKey(r)] ? ' gk-selected' : '')}>
              <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
              <td className="gk-nowrap">
                <button className={'gk-kbtn gp-knopf' + (ps ? ' on' : '')}
                        onClick={() => setOffenP(o => ({ ...o, [pk]: !o[pk] }))}
                        title={ps ? `zuletzt gespeichert ${ps.erstellt}` : 'noch kein Satz'}>
                  {pAuf ? '▾ zu' : '✎'} {!pAuf && prozessStand(ps)}
                </button>
              </td>
              <td><span className={'gk-badge ' + (r.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{r.typ}</span></td>
              <td className="gk-nowrap">{r.zeitraum}</td>
              <td><strong>{r.campaign}</strong></td>
              <td className="r">{num(r.impr)}</td>
              <td className="r">{r.masked ? <span className="gk-muted" title="Google maskiert IS unter 10 % — kein exakter Wert">&lt; 10 %</span> : pct(r.is)}</td>
              <td className="r">{pct(r.lost_rang)}</td>
              <td className="r">{pct(r.lost_budget)}</td>
            </tr>
            {pAuf && (
              <tr className="gk-detail">
                <td></td>
                <ProzessZeile
                  bericht="b02"
                  schluessel={{ campaign: r.campaign, periode_typ: r.typ, periode: r.zeitraum, objekt: (r.domain || 'eigen') }}
                  satz={ps}
                  gebotIst={undefined}
                  geoId={undefined}
                  onGespeichert={prozessNeuLaden}
                  spalten={8}
                />
              </tr>
            )}
            </React.Fragment>
          );})}
        </tbody>
      </table>
      <div className="gk-note">
        Eigene Auktions-Position via GAds-API-Fenster ab 01.01.2026 — Wochen (Fr–Do, wie B01) + Monate. IS + Lost-Rang + Lost-Budget = 100 % (vollständige Impression-Share-Bilanz), deckt sich mit „GADS letzte 7 Tage" (freitags).<br />
        <strong>„&lt; 10 %"</strong> = Googles Maske (IS unter 10 % gibt Google nicht exakt aus). oberste/obere Position siehe B01 (gleiche API-Metrik, keine Dublette). Konkurrenz-Domains: manueller Import auf der Ads-Performance-Seite.
      </div>
    </div>
    </>
  );
}

// ---------- B03 · Geräte ----------
const gb = g => (g == null ? '—' : (g > 0 ? '+' : '') + g + ' %'); // Gebotsanpassung

function B03Geraete({ selectedK }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [saetze, prozessNeuLaden] = useProzess('b03');   // Prozess-Felder je Perioden-Zeile
  const [offen, setOffen] = useState({});                // welche Edit-Zeile ist aufgeklappt

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_b03.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setRows(j.rows); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!rows) return <div className="gk-placeholder">lädt…</div>;
  const shown = rows.filter(r => !selectedK || selectedK[r.campaign]);
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}|${r.device}`;
  // Prozess-Schlüssel: andere Reihenfolge als rowKey, weil der Endpunkt
  // campaign zuerst gruppiert — nicht zusammenlegen, sie bedeuten Verschiedenes.
  // 🔴 Seit dem 2026-10-19 über prozessKey(). Diese Stelle hiess `pKey` statt `pk`
  //    und blieb beim Umbau zurück — gefunden hat sie bin/op-verwaist beim ersten
  //    Lauf, weil sein Muster die FORM sucht und nicht den Variablennamen.
  const pKey = r => prozessKey(r, r.device);
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const allChecked = shown.every(r => sel[rowKey(r)]);
  const toggleAll = () => { const v = !allChecked; const n = { ...sel }; shown.forEach(r => { n[rowKey(r)] = v; }); setSel(n); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;

  const exportCsv = () => {
    const cols = [
      ['Typ', 'typ', 0], ['Zeitraum', 'zeitraum', 0], ['Kampagne', 'campaign', 0], ['Gerät', 'device', 0],
      ['Kosten', 'costs', 1], ['Impressionen', 'impr', 1], ['Klicks', 'clicks', 1], ['CTR %', 'ctr', 1], ['Ø CPC', 'cpc', 1],
      ['Conversions', 'conv', 1], ['Kosten/Conv.', 'cpa', 1], ['Conv.-Rate %', 'convrate', 1],
      ['oberste %', 'oberste', 1], ['obere %', 'obere', 1], ['Gebotsanp.', 'gebot', 0],
    ];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => {
      if (c[1] === 'gebot') return r.gebot == null ? '' : (r.gebot > 0 ? '+' : '') + r.gebot;
      const v = r[c[1]]; if (v == null) return ''; const s = c[2] ? String(v).replace('.', ',') : String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'gads_b03_geraete.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <span className="gk-toolbar-hint">Geräte je Kampagne (nur mit Traffic) — Zeilen links wählen</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"><input type="checkbox" checked={allChecked} onChange={toggleAll} title="alle" /></th>
            <th title="Ursache · Handlung · WirkHand · Prüfung">Prozess</th>
            <th>Typ</th><th>Zeitraum</th><th>K</th><th>Gerät</th>
            <th className="r">Kosten</th><th className="r">Impr.</th><th className="r">Klicks</th>
            <th className="r">CTR</th><th className="r">Ø CPC</th><th className="r">Conv.</th>
            <th className="r">Kosten/Conv.</th><th className="r">Conv.-Rate</th>
            <th className="r">oberste %</th><th className="r">obere %</th><th className="r">Gebot</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((r, i) => {
            const k = pKey(r);
            const satz = saetze[k];
            const auf = !!offen[k];
            return (
            <React.Fragment key={i}>
            <tr className={(r.typ === 'Monat' ? 'gk-monat' : '') + (sel[rowKey(r)] ? ' gk-selected' : '')}>
              <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
              <td className="gk-nowrap">
                <button className={'gk-kbtn gp-knopf' + (satz ? ' on' : '')}
                        onClick={() => setOffen(o => ({ ...o, [k]: !o[k] }))}
                        title={satz ? `zuletzt gespeichert ${satz.erstellt}` : 'noch kein Satz'}>
                  {auf ? '▾ zu' : '✎'} {!auf && prozessStand(satz)}
                </button>
              </td>
              <td><span className={'gk-badge ' + (r.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{r.typ}</span></td>
              <td className="gk-nowrap">{r.zeitraum}</td>
              <td><strong>{r.campaign}</strong></td>
              <td className="gk-nowrap">{r.device}</td>
              <td className="r">{eur(r.costs)}</td>
              <td className="r">{num(r.impr)}</td>
              <td className="r">{num(r.clicks)}</td>
              <td className="r">{pct(r.ctr)}</td>
              <td className="r">{eur(r.cpc)}</td>
              <td className="r">{num(r.conv)}</td>
              <td className="r">{eur(r.cpa)}</td>
              <td className="r">{pct(r.convrate)}</td>
              <td className="r">{pct(r.oberste)}</td>
              <td className="r">{pct(r.obere)}</td>
              {/* Gebot: links der gemessene Ist-Wert aus Google Ads, rechts der
                  gespeicherte Soll-Wert - sonst ist die Eingabe unsichtbar,
                  sobald die Prozess-Zone zu ist (Georg 2026-10-10) */}
              <td className="r gk-nowrap">
                {gb(r.gebot)}
                {satz && satz.gebot_soll != null && (
                  <span className="gk-warn"> → {satz.gebot_soll > 0 ? '+' : ''}{satz.gebot_soll} %
                    {satz.gebot_gesetzt ? '' : '*'}</span>
                )}
              </td>
            </tr>
            {auf && (
              <tr className="gk-detail">
                <td></td>
                <ProzessZeile
                  bericht="b03"
                  schluessel={{ campaign: r.campaign, periode_typ: r.typ, periode: r.zeitraum, objekt: r.device }}
                  satz={satz}
                  gebotIst={r.gebot}
                  onGespeichert={prozessNeuLaden}
                  spalten={16}
                />
              </tr>
            )}
            </React.Fragment>
          );})}
        </tbody>
      </table>
      <div className="gk-note">
        Gerätebericht je Kampagne — eine Zeile je Gerät mit Traffic (Smartphones/Computer/Tablets; 0 Impressionen → keine Zeile), Wochen (Fr–Do) + Monate ab 01.01.2026. Additive Werte aus der Tagestabelle (30 T rollierend) aggregiert, Verhältnisse daraus neu gerechnet; oberste/obere % per API-Fenster-Pull (CSV-verifiziert); <strong>Gebot</strong> = aktuelle Geräte-Gebotsanpassung („—" = keine gesetzt).
        <br /><strong>Gebot-Spalte:</strong> links der gemessene Ist-Wert aus Google Ads, nach dem Pfeil der
        gespeicherte Soll-Wert. Ein <strong>*</strong> dahinter heißt: <strong>nur notiert, noch nicht ins Konto
        geschrieben</strong> — Du setzt ihn bis auf Weiteres selbst in Google Ads.
        <br /><strong>Prozess-Spalte:</strong> ein Satz je Zeile (Kampagne × Gerät × Zeitraum). Jeder Speichern-Klick
        legt eine neue Fassung an, die vorigen bleiben als Historie stehen.
      </div>
    </div>
    </>
  );
}

// ---------- B04 · Alter ----------
function B04Alter({ selectedK }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [saetze, prozessNeuLaden] = useProzess('b04');
  const [offenP, setOffenP] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/gads_kpi_b04.php`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setRows(j.rows); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!rows) return <div className="gk-placeholder">lädt…</div>;
  const shown = rows.filter(r => !selectedK || selectedK[r.campaign]);
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}|${r.age}`;
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const allChecked = shown.every(r => sel[rowKey(r)]);
  const toggleAll = () => { const v = !allChecked; const n = { ...sel }; shown.forEach(r => { n[rowKey(r)] = v; }); setSel(n); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;

  const exportCsv = () => {
    const cols = [
      ['Typ', 'typ', 0], ['Zeitraum', 'zeitraum', 0], ['Kampagne', 'campaign', 0], ['Alter', 'age', 0],
      ['Kosten', 'costs', 1], ['Impressionen', 'impr', 1], ['Klicks', 'clicks', 1], ['CTR %', 'ctr', 1], ['Ø CPC', 'cpc', 1],
      ['Conversions', 'conv', 1], ['Kosten/Conv.', 'cpa', 1], ['Conv.-Rate %', 'convrate', 1], ['Gebotsanp.', 'gebot', 0],
    ];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => {
      if (c[1] === 'gebot') return r.gebot == null ? '' : (r.gebot > 0 ? '+' : '') + r.gebot;
      const v = r[c[1]]; if (v == null) return ''; const s = c[2] ? String(v).replace('.', ',') : String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'gads_b04_alter.csv'; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <span className="gk-toolbar-hint">Nur aktive Altersgruppen mit Traffic — Zeilen links wählen</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"><input type="checkbox" checked={allChecked} onChange={toggleAll} title="alle" /></th>
            <th title="Ursache · Handlung · WirkHand · Prüfung">Prozess</th>
            <th>Typ</th><th>Zeitraum</th><th>K</th><th>Alter</th>
            <th className="r">Kosten</th><th className="r">Impr.</th><th className="r">Klicks</th>
            <th className="r">CTR</th><th className="r">Ø CPC</th><th className="r">Conv.</th>
            <th className="r">Kosten/Conv.</th><th className="r">Conv.-Rate</th><th className="r">Gebot</th>
          </tr>
        </thead>
        <tbody>
          {shown.map((r, i) => {
            const pk = prozessKey(r, r.age);
            const ps = saetze[pk];
            const pAuf = !!offenP[pk];
            return (
            <React.Fragment key={i}>
            <tr className={(r.typ === 'Monat' ? 'gk-monat' : '') + (sel[rowKey(r)] ? ' gk-selected' : '')}>
              <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
              <td className="gk-nowrap">
                <button className={'gk-kbtn gp-knopf' + (ps ? ' on' : '')}
                        onClick={() => setOffenP(o => ({ ...o, [pk]: !o[pk] }))}
                        title={ps ? `zuletzt gespeichert ${ps.erstellt}` : 'noch kein Satz'}>
                  {pAuf ? '▾ zu' : '✎'} {!pAuf && prozessStand(ps)}
                </button>
              </td>
              <td><span className={'gk-badge ' + (r.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{r.typ}</span></td>
              <td className="gk-nowrap">{r.zeitraum}</td>
              <td><strong>{r.campaign}</strong></td>
              <td className="gk-nowrap">{r.age}</td>
              <td className="r">{eur(r.costs)}</td>
              <td className="r">{num(r.impr)}</td>
              <td className="r">{num(r.clicks)}</td>
              <td className="r">{pct(r.ctr)}</td>
              <td className="r">{eur(r.cpc)}</td>
              <td className="r">{num(r.conv)}</td>
              <td className="r">{eur(r.cpa)}</td>
              <td className="r">{pct(r.convrate)}</td>
              <td className="r">{gb(r.gebot)}</td>
            </tr>
            {pAuf && (
              <tr className="gk-detail">
                <td></td>
                <ProzessZeile
                  bericht="b04"
                  schluessel={{ campaign: r.campaign, periode_typ: r.typ, periode: r.zeitraum, objekt: r.age }}
                  satz={ps}
                  gebotIst={r.gebot}
                  geoId={undefined}
                  onGespeichert={prozessNeuLaden}
                  spalten={14}
                />
              </tr>
            )}
            </React.Fragment>
          );})}
        </tbody>
      </table>
      <div className="gk-note">
        Altersdemografie je Kampagne — nur aktive Altersgruppen mit Traffic (0 Impressionen / ausgeschlossen → keine Zeile), Wochen (Fr–Do) + Monate ab 01.01.2026. Additive Werte aus der Tagestabelle aggregiert, Verhältnisse daraus neu gerechnet; <strong>Gebot</strong> = aktuelle Alters-Gebotsanpassung („—" = keine). Anteilsmetriken (IS/Lost-Rang/exact-match) liefert die GAds-API auf Altersebene nicht — daher hier nicht enthalten (Kampagnen-IS siehe B01/B02).
      </div>
    </div>
    </>
  );
}

// ---------- Gruppierter Breakdown (B05/B06): je (Periode × Kampagne) einklappbar ----------
// Kopfzeile = Summe der Gruppe (= Wochen-/Monats-KPI der Kampagne), aufklappen zeigt die Segment-Zeilen.
const XF = { eur, pct, num, text: v => (v == null || v === '' ? '—' : String(v)) };
/**
 * @param prozess  optional. {bericht, objekt:(r)=>string, gebotFeld?:'gebot', geoFeld?:'geo_id'}
 *                 Ist es gesetzt, bekommt JEDE Detailzeile eine Prozess-Spalte mit
 *                 aufklappbaren Feldern. Ohne das Prop ändert sich nichts — die zehn
 *                 Panels, die GroupedReport sonst nutzen, bleiben unberührt (2026-10-10).
 */
function GroupedReport({ selectedK, url, segCols, csvName, unit, hint, note, shares = false, gebot = true, extraCols = [], prozess = null }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [sel, setSel] = useState({});
  const [openG, setOpenG] = useState({});
  const [saetze, prozessNeuLaden] = useProzess(prozess ? prozess.bericht : null);
  const [offenP, setOffenP] = useState({});

  useEffect(() => {
    const token = localStorage.getItem('token') || '';
    fetch(`${API_BASE}/${url}`, { headers: { 'Authorization': 'Bearer ' + token } })
      .then(r => r.json())
      .then(j => { if (j.success) setRows(j.rows); else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, [url]);

  if (err) return <div className="gk-err">Fehler: {err}</div>;
  if (!rows) return <div className="gk-placeholder">lädt…</div>;
  const shown = rows.filter(r => !selectedK || selectedK[r.campaign]);
  if (!shown.length) return <div className="gk-placeholder">keine Kampagne ausgewählt (oder keine Daten)</div>;

  const segVal = r => segCols.map(c => r[c.key]).join(' · ');
  const rowKey = r => `${r.typ}|${r.zeitraum}|${r.campaign}|${segVal(r)}`;
  // Gruppieren nach (Typ × Zeitraum × Kampagne) — Reihenfolge aus der bereits sortierten Liste
  const groups = []; const gmap = {};
  shown.forEach(r => {
    const gk = `${r.typ}|${r.zeitraum}|${r.campaign}`;
    if (!gmap[gk]) { gmap[gk] = { key: gk, typ: r.typ, zeitraum: r.zeitraum, campaign: r.campaign, rows: [] }; groups.push(gmap[gk]); }
    gmap[gk].rows.push(r);
  });
  const agg = grp => {
    let costs = 0, impr = 0, clicks = 0, conv = 0;
    grp.rows.forEach(r => { costs += r.costs || 0; impr += r.impr || 0; clicks += r.clicks || 0; conv += r.conv || 0; });
    return {
      costs: Math.round(costs * 100) / 100, impr, clicks, conv,
      ctr: impr ? Math.round((clicks / impr) * 10000) / 100 : 0,
      cpc: clicks ? Math.round((costs / clicks) * 100) / 100 : 0,
      cpa: conv ? Math.round((costs / conv) * 100) / 100 : null,
      convrate: clicks ? Math.round((conv / clicks) * 10000) / 100 : 0,
    };
  };

  const toggleG = k => setOpenG(o => ({ ...o, [k]: !o[k] }));
  const setAllG = v => setOpenG(v ? Object.fromEntries(groups.map(g => [g.key, true])) : {});
  const toggleRow = k => setSel(s => ({ ...s, [k]: !s[k] }));
  const groupChecked = g => g.rows.every(r => sel[rowKey(r)]);
  const toggleGroupSel = g => { const v = !groupChecked(g); setSel(s => { const n = { ...s }; g.rows.forEach(r => { n[rowKey(r)] = v; }); return n; }); };
  const pickedCount = shown.filter(r => sel[rowKey(r)]).length;

  const exportCsv = () => {
    const cols = [
      ['Typ', 'typ', 0], ['Zeitraum', 'zeitraum', 0], ['Kampagne', 'campaign', 0],
      ...segCols.map(c => [c.label, c.key, 0]),
      ['Kosten', 'costs', 1], ['Impressionen', 'impr', 1], ['Klicks', 'clicks', 1], ['CTR %', 'ctr', 1], ['Ø CPC', 'cpc', 1],
      ['Conversions', 'conv', 1], ['Kosten/Conv.', 'cpa', 1], ['Conv.-Rate %', 'convrate', 1],
      ...(shares ? [['oberste %', 'oberste', 1], ['obere %', 'obere', 1]] : []),
      ...(gebot ? [['Gebotsanp.', 'gebot', 0]] : []),
      ...extraCols.map(c => [c.label, c.key, c.t === 'text' ? 0 : 1]),
    ];
    const picked = shown.filter(r => sel[rowKey(r)]);
    if (!picked.length) { alert('Keine Zeile ausgewählt.'); return; }
    const cell = (r, c) => {
      if (c[1] === 'gebot') return r.gebot == null ? '' : (r.gebot > 0 ? '+' : '') + r.gebot;
      const v = r[c[1]]; if (v == null) return ''; const s = c[2] ? String(v).replace('.', ',') : String(v); return /[";\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    let csv = '﻿' + cols.map(c => c[0]).join(';') + '\n';
    picked.forEach(r => { csv += cols.map(c => cell(r, c)).join(';') + '\n'; });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = csvName; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
  };

  const nseg = segCols.length;
  return (
    <>
    <div className="gk-toolbar">
      <button className="gk-kbtn" onClick={exportCsv} disabled={!pickedCount}>⬇ CSV-Export{pickedCount ? ` (${pickedCount})` : ''}</button>
      <button className="gk-kbtn" onClick={() => setAllG(true)}>Alle auf</button>
      <button className="gk-kbtn" onClick={() => setAllG(false)}>Alle zu</button>
      <span className="gk-toolbar-hint">{groups.length} Gruppen · {hint}</span>
    </div>
    <div className="gk-tablewrap">
      <table className="gk-table">
        <thead>
          <tr>
            <th className="gk-chkcol"></th>
            {prozess && <th title="Ursache · Handlung · WirkHand · Prüfung">Prozess</th>}
            <th>Typ</th><th>Zeitraum</th><th>K</th>{segCols.map(c => <th key={c.key}>{c.label}</th>)}
            <th className="r">Kosten</th><th className="r">Impr.</th><th className="r">Klicks</th>
            <th className="r">CTR</th><th className="r">Ø CPC</th><th className="r">Conv.</th>
            <th className="r">Kosten/Conv.</th><th className="r">Conv.-Rate</th>
            {shares && <><th className="r">oberste %</th><th className="r">obere %</th></>}
            {gebot && <th className="r">Gebot</th>}
            {extraCols.map(c => <th key={c.key} className={c.t === 'text' ? '' : 'r'}>{c.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {groups.map(g => {
            const a = agg(g); const isOpen = !!openG[g.key];
            return (
              <React.Fragment key={g.key}>
                <tr className="gk-grouphead" onClick={() => toggleG(g.key)}>
                  <td className="gk-chkcol" onClick={e => e.stopPropagation()}><input type="checkbox" checked={groupChecked(g)} onChange={() => toggleGroupSel(g)} title="Gruppe wählen" /></td>
                  {prozess && <td></td>}
                  <td className="gk-nowrap"><span className="gk-caret">{isOpen ? '▾' : '▸'}</span> <span className={'gk-badge ' + (g.typ === 'Monat' ? 'gk-b-mon' : 'gk-b-wk')}>{g.typ}</span></td>
                  <td className="gk-nowrap">{g.zeitraum}</td>
                  <td><strong>{g.campaign}</strong></td>
                  <td className="gk-muted2" colSpan={nseg}>{g.rows.length} {unit}</td>
                  <td className="r">{eur(a.costs)}</td>
                  <td className="r">{num(a.impr)}</td>
                  <td className="r">{num(a.clicks)}</td>
                  <td className="r">{pct(a.ctr)}</td>
                  <td className="r">{eur(a.cpc)}</td>
                  <td className="r">{num(a.conv)}</td>
                  <td className="r">{eur(a.cpa)}</td>
                  <td className="r">{pct(a.convrate)}</td>
                  {shares && <><td className="r"></td><td className="r"></td></>}
                  {gebot && <td className="r"></td>}
                  {extraCols.map(c => <td key={c.key} className="r"></td>)}
                </tr>
                {isOpen && g.rows.map((r, i) => {
                  // Ohne eigene objekt-Funktion ist das Objekt die Segment-Spalte(n) der Zeile -
                  // bei B09 also Keyword UND Match-Type, sonst verschmelzen zwei Objekte
                  const pObj = prozess ? (prozess.objekt ? prozess.objekt(r) : segVal(r)) : null;
                  const pk = prozess ? prozessKey(r, pObj) : null;
                  const ps = pk ? saetze[pk] : null;
                  const pAuf = pk ? !!offenP[pk] : false;
                  return (
                  <React.Fragment key={i}>
                  <tr className={'gk-detail' + (sel[rowKey(r)] ? ' gk-selected' : '')}>
                    <td className="gk-chkcol"><input type="checkbox" checked={!!sel[rowKey(r)]} onChange={() => toggleRow(rowKey(r))} /></td>
                    {prozess && (
                      <td className="gk-nowrap">
                        <button className={'gk-kbtn gp-knopf' + (ps ? ' on' : '')}
                                onClick={() => setOffenP(o => ({ ...o, [pk]: !o[pk] }))}
                                title={ps ? `zuletzt gespeichert ${ps.erstellt}` : 'noch kein Satz'}>
                          {pAuf ? '▾ zu' : '✎'} {!pAuf && prozessStand(ps)}
                        </button>
                      </td>
                    )}
                    <td></td><td></td><td></td>
                    {segCols.map(c => <td key={c.key} className="gk-nowrap">{r[c.key]}</td>)}
                    <td className="r">{eur(r.costs)}</td>
                    <td className="r">{num(r.impr)}</td>
                    <td className="r">{num(r.clicks)}</td>
                    <td className="r">{pct(r.ctr)}</td>
                    <td className="r">{eur(r.cpc)}</td>
                    <td className="r">{num(r.conv)}</td>
                    <td className="r">{eur(r.cpa)}</td>
                    <td className="r">{pct(r.convrate)}</td>
                    {shares && <><td className="r">{pct(r.oberste)}</td><td className="r">{pct(r.obere)}</td></>}
                    {gebot && (
                      <td className="r gk-nowrap">
                        {gb(r.gebot)}
                        {ps && ps.gebot_soll != null && (
                          <span className="gk-warn"> → {ps.gebot_soll > 0 ? '+' : ''}{ps.gebot_soll} %
                            {ps.gebot_gesetzt ? '' : '*'}</span>
                        )}
                      </td>
                    )}
                    {extraCols.map(c => <td key={c.key} className={c.t === 'text' ? 'gk-nowrap' : 'r'}>{XF[c.t](r[c.key])}</td>)}
                  </tr>
                  {prozess && pAuf && (
                    <tr className="gk-detail">
                      <td></td>
                      <ProzessZeile
                        bericht={prozess.bericht}
                        schluessel={{ campaign: r.campaign, periode_typ: r.typ, periode: r.zeitraum, objekt: pObj }}
                        satz={ps}
                        gebotIst={gebot ? r.gebot : undefined}
                        geoId={prozess.geoFeld ? r[prozess.geoFeld] : undefined}
                        onGespeichert={prozessNeuLaden}
                        spalten={4 + segCols.length + 8 + (shares ? 2 : 0) + (gebot ? 1 : 0) + extraCols.length}
                      />
                    </tr>
                  )}
                  </React.Fragment>
                );})}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      <div className="gk-note">{note}</div>
    </div>
    </>
  );
}

// ---------- B05 · Standorte ----------
function B05Standorte({ selectedK }) {
  // B05 ist der zweite Bericht mit Prozess-Feldern. Anders als B03: kein Gebot über
  // alle Standorte - jeder Standort trägt sein eigenes campaign_criterion, adressiert
  // über geo_id (Georg 2026-10-10). Bis zu 25 Standorte je Gruppe.
  return <GroupedReport selectedK={selectedK} url="gads_kpi_b05.php" segCols={[{ label: 'Standort', key: 'standort' }]}
    prozess={{ bericht: 'b05', objekt: r => r.standort, geoFeld: 'geo_id' }}
    csvName="gads_b05_standorte.csv" unit="Standorte" hint="Kopf = Wochen-/Monats-Summe, aufklappen für Standort-Details"
    note={<>Standortbericht je Kampagne (Bundesland-Granularität) — je (Woche/Monat × Kampagne) eine einklappbare Gruppe (Kopf = Summe = Wochen-KPI der Kampagne), aufklappen zeigt die Standorte mit Traffic (meiste zuerst). Wochen (Fr–Do) + Monate ab 01.01.2026, additiv aus der Tagestabelle, Verhältnisse neu gerechnet; <strong>Gebot</strong> = aktuelle Standort-Gebotsanpassung. oberste/obere % liefert die GAds-API auf Standortebene nicht.</>} />;
}

// ---------- B06 · Werbezeitplan ----------
function B06Zeitplan({ selectedK }) {
  return <GroupedReport selectedK={selectedK} prozess={{ bericht: 'b06' }} url="gads_kpi_b06.php" segCols={[{ label: 'Tag', key: 'tag' }, { label: 'Zeit', key: 'zeit' }]}
    csvName="gads_b06_werbezeitplan.csv" unit="Slots" hint="Kopf = Wochen-/Monats-Summe, aufklappen für Tag × Zeitfenster"
    note={<>Werbezeitplan je Kampagne — je (Woche/Monat × Kampagne) eine einklappbare Gruppe (Kopf = Summe = Wochen-KPI der Kampagne), aufklappen zeigt Tag × Zeitfenster (deine 6 Dayparts) mit Traffic, Mo→So. Wochen (Fr–Do) + Monate ab 01.01.2026, aus der stündlichen Tagestabelle aggregiert; <strong>Gebot</strong> = aktuelle Zeitplan-Gebotsanpassung. Conv.-Wert / Alle-Conv. nicht enthalten (= Conversions).</>} />;
}

// ---------- B07 · Zielgruppen ----------
function B07Zielgruppen({ selectedK }) {
  return <GroupedReport selectedK={selectedK} prozess={{ bericht: 'b07' }} url="gads_kpi_b07.php" segCols={[{ label: 'Segment', key: 'segment' }]}
    csvName="gads_b07_zielgruppen.csv" unit="Segmente" hint="Kopf = Summe der beobachteten Segmente (Klicks>0), aufklappen für Details"
    note={<>Zielgruppensegmente (Beobachtung) je Kampagne — je (Woche/Monat × Kampagne) eine einklappbare Gruppe, aufklappen zeigt die Segmente mit <strong>Klicks &gt; 0</strong> (= CSV-„Gefilterte Zielgruppen"; die Summe ist kleiner als die Kampagne, da Beobachtung nur einen Teil erfasst). Additiv aus der Tagestabelle, <strong>Gebot</strong> = aktuelle Segment-Gebotsanpassung (uservertical-aufgelöst). <em>Namen englisch</em> (API-kanonisch); Typ + Anteilsmetriken (IS/oberste/obere) gibt die GAds-API auf Segmentebene nicht her.</>} />;
}

// ---------- B08 · Suchbegriffe ----------
function B08Suchbegriffe({ selectedK }) {
  return <GroupedReport selectedK={selectedK} prozess={{ bericht: 'b08' }} url="gads_kpi_b08.php" shares gebot={false}
    segCols={[{ label: 'Suchbegriff', key: 'suchbegriff' }, { label: 'Option', key: 'option' }, { label: 'Keyword', key: 'keyword' }]}
    csvName="gads_b08_suchbegriffe.csv" unit="Suchbegriffe" hint="Status „Keines“ (unbearbeitet), aufklappen für Details"
    note={<>Suchbegriffe je Kampagne — <strong>nur Status „Keines"</strong> (noch nicht als Keyword hinzugefügte / nicht ausgeschlossene Queries = Kandidaten für Negatives &amp; neue Keywords; die bereits verwalteten sind ausgeblendet), wöchentlich (Fr–Do) ab 01.01.2026, einklappbar. Direkt aus <code>search_term_view</code> (echter Match-Type + oberste/obere je Suchbegriff × matched Keyword). Kein Monat (Search-Term-Long-Tail nicht sinnvoll aggregierbar).</>} />;
}

// ---------- B09 · Keywords ----------
function B09Keywords({ selectedK }) {
  return <GroupedReport selectedK={selectedK} prozess={{ bericht: 'b09' }} url="gads_kpi_b09.php" gebot={false}
    segCols={[{ label: 'Keyword', key: 'keyword' }, { label: 'Option', key: 'option' }]}
    extraCols={[
      { label: 'Max CPC', key: 'maxcpc', t: 'eur' },
      { label: 'QS', key: 'qs', t: 'num' },
      { label: 'Anz.-Rel.', key: 'rel', t: 'text' },
      { label: 'Erw. CTR', key: 'ectr', t: 'text' },
      { label: 'LP-Erf.', key: 'lp', t: 'text' },
      { label: 'Geb. 1.Seite', key: 'bid_first', t: 'eur' },
      { label: 'Geb. oberste', key: 'bid_top', t: 'eur' },
      { label: 'Geb. obere', key: 'bid_tp', t: 'eur' },
    ]}
    csvName="gads_b09_keywords.csv" unit="Keywords" hint="aktive Keywords (inkl. 0 Impr — wegen Max CPC), aufklappen für Details"
    note={<>Keywords je Kampagne — aktive Keywords (Keyword + Anzeigengruppe + Kampagne ENABLED, keine Ausschluss-Keywords), Wochen (Fr–Do) + Monate ab 01.01.2026, einklappbar. <strong>Auch 0-Impressionen-Keywords</strong> (wegen Max CPC). Metriken periodenspezifisch aus <code>keyword_view</code>; <strong>Max CPC · Qualitätsfaktor · Anz.-Rel./Erw. CTR/LP-Erf. · Gesch. Gebote</strong> (1. Seite / oberste / obere Position) = aktuelle Werte (Setting-Charakter).</>} />;
}

// ---------- B10 · Titel (Anzeigentitel) ----------
function B10Titel({ selectedK }) {
  return <GroupedReport selectedK={selectedK} url="gads_kpi_assets.php?type=Titel" gebot={false} prozess={{ bericht: 'b10' }}
    segCols={[{ label: 'Titel', key: 'asset' }]}
    csvName="gads_b10_titel.csv" unit="Titel" hint="Anzeigentitel je Kampagne, aufklappen für Details"
    note={<>Anzeigentitel (Headlines der responsiven Suchanzeigen) je Kampagne — je (Woche/Monat × Kampagne) eine einklappbare Gruppe, aufklappen zeigt die Titel-Assets (inkl. 0-Impr). Wochen (Fr–Do) + Monate ab 01.01.2026, aus <code>ad_group_ad_asset_view</code> (ENABLED), je Asset über die Anzeigen aggregiert, inkl. Conversions.</>} />;
}

// ---------- B11 · Texte (Textzeilen) ----------
function B11Texte({ selectedK }) {
  return <GroupedReport selectedK={selectedK} url="gads_kpi_assets.php?type=Text" gebot={false} prozess={{ bericht: 'b11' }}
    segCols={[{ label: 'Text', key: 'asset' }]}
    csvName="gads_b11_texte.csv" unit="Texte" hint="Textzeilen je Kampagne, aufklappen für Details"
    note={<>Textzeilen (Descriptions der responsiven Suchanzeigen) je Kampagne — einklappbar, Wochen (Fr–Do) + Monate ab 01.01.2026, aus <code>ad_group_ad_asset_view</code> (ENABLED), je Asset aggregiert, inkl. Conversions.</>} />;
}

// ---------- B12 · Sitelinks ----------
function B12Sitelinks({ selectedK }) {
  return <GroupedReport selectedK={selectedK} url="gads_kpi_assets.php?type=Sitelink" gebot={false} prozess={{ bericht: 'b12' }}
    segCols={[{ label: 'Sitelink', key: 'asset' }]}
    csvName="gads_b12_sitelinks.csv" unit="Sitelinks" hint="Sitelinks je Kampagne, aufklappen für Details"
    note={<>Sitelinks je Kampagne — einklappbar, Wochen (Fr–Do) + Monate ab 01.01.2026, aus <code>campaign_asset</code> (field_type SITELINK), je Asset inkl. Conversions.</>} />;
}

// ---------- B13 · Marke (Logo + Firmenname) ----------
function B13Marke({ selectedK }) {
  return <GroupedReport selectedK={selectedK} url="gads_kpi_assets.php?type=Marke" gebot={false} prozess={{ bericht: 'b13' }}
    segCols={[{ label: 'Typ', key: 'atyp' }, { label: 'Asset', key: 'asset' }]}
    csvName="gads_b13_marke.csv" unit="Marken-Assets" hint="Logo + Firmenname je Kampagne, aufklappen für Details"
    note={<>Marken-Assets (Logo + Name des Unternehmens) je Kampagne — einklappbar, aus <code>campaign_asset</code> (BUSINESS_LOGO + BUSINESS_NAME), inkl. Conversions.</>} />;
}

// ---------- B14 · Bilder ----------
function B14Bilder({ selectedK }) {
  return <GroupedReport selectedK={selectedK} url="gads_kpi_assets.php?type=Bild" gebot={false} prozess={{ bericht: 'b14' }}
    segCols={[{ label: 'Bild', key: 'asset' }]}
    csvName="gads_b14_bilder.csv" unit="Bilder" hint="Bild-Assets je Kampagne, aufklappen für Details"
    note={<>Bild-Assets (Bild-Erweiterungen) je Kampagne — einklappbar, aus <code>campaign_asset</code> (field_type AD_IMAGE), je Asset inkl. Conversions (Asset-Name statt tpc-URL, wo vorhanden).</>} />;
}
